/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from "@mui/material";
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TEXT from "../../../../src/utils/globalText";
import AdditionalRecipient from "../../../components/AdditionalRecipient";
import FullScreen from "../../../components/FullScreen";
import Loader from "../../../components/Loader/Index";
import useServiceChecker from "../../../components/ServiceChecker";
import CommonAlertsStrip from "../../../components/_utils/CommonAlertsStrip";
import CommonBankLogo from "../../../components/_utils/CommonBankLogo";
import SwitcherTabs from "../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavLargeButton from "../../../components/_utils/CommonButtons/TopNavLargeButton";
import TopNavSmallButton from "../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../components/_utils/CommonContainerCard";
import CommonDetailCard from "../../../components/_utils/CommonDetailCard";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import EditCommonPopup from "../../../components/_utils/CommonPopups/CommonEditPopup";
import LargePopupRedirect from "../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../components/_utils/CommonSmallPopup";
import SmallPopupWithInput from "../../../components/_utils/CommonSmallPopupWithInput";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber";
import TickerAnimation from "../../../components/_utils/TickerAnimation";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair";
import UniversalRefreshToast from "../../../components/_utils/UniversalRefreshToast";
import IFSCDetails from "../../../containers/Settings/IFSCDetails";
import "./index.css";
import GSTVerification from "../../../containers/Settings/GSTDetails";
import PanVerification from "../../../containers/Settings/PanVerification";
import {
  resetBeneficiaryBankUpdate,
  resetUpdateBeneficiaryAccount,
} from "../../../redux/features/accounts/beneficiaryAccount/index.js";
import { beneVerifyThisPAN } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  beneTxnMultiDeniedApproval,
  beneTxnViewAllAcc,
} from "../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import { resetInEdit } from "../../../redux/features/verifyPAN/verifyPAN";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  ScreenSizeConfiguration,
  TimelineConfiguration,
} from "../../../utils/configurationProvider";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import useCategories from "../../../utils/useCategories";
import { linkIdentifier } from "../../../utils/linkIdentifier";
import FieldForceTransactionViewAll from "../../FieldForceTransactions/FieldForceTransactionsViewAll";
import ICONS from "../../../assets/Icons";
import UserDetailsPopup from "../../../components/Settings/User/UserDetailsPopup/index.jsx";
import CommonToast from "../../../components/_utils/CommonToast";
import {
  addFieldForceAccNewLabel,
  archiveFieldForceAccount,
  editFieldForceAccount,
  filedForceApproval,
  filedForceDeniedAccount,
  getSpecificFieldForceAccount,
  removeFieldForceAccNewLabel,
  resetEditFieldForceAccountData,
  resetToggleFfa,
  unarchiveFieldForceAccount,
} from "../../../redux/features/accounts/fieldForceAccount";
import FieldForceAccountViewAll from "../FieldForceAccountViewAll/index.jsx";
import FieldForceAccountAssociatePopup from "../FieldForceAccountViewAll/FieldForceAccountAssociatePopup/index.jsx";
import { toast } from "react-toastify";
import Chips from "../../../components/_utils/CommonButtons/Chips/index.jsx";
import { FieldForceMultiTxnDeniedApproval } from "../../../redux/features/fieldForceTransaction/index.js";
import { fieldforcerequestTxnReject } from "../../../redux/features/fieldForceRequest/index.js";
import FieldForceTxnRequestViewAll from "../../FieldForceRequestTransactions/FieldForceTxnRequestViewAll/index.jsx";
import FieldForceRequestViewAllPopup from "../../../components/FieldForceTransactionComp/FieldForceRequestViewAllPopup/index.jsx";
import useRestrictedAction from "../../../hooks/useRestrictedAction.js";
import SmallPopupWithBulletPoints from "../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import SVGComponent from "../../../components/_utils/SVGComponent/index.jsx";

const FieldForceAccountDetails = (payload) => {
  const { onSuccess } = payload;
  const { archiveFieldForceAccountloading, editFieldForceAccountLoading } =
    useSelector((state) => state.fieldForceAccount);

  const fieldForceAccountId =
    payload?.field_force_account_id ?? payload?.bene_account_id;
  const embeddedBeneTxnModalType =
    payload?.type === "field_force_account_detail_modal"
      ? "bene_account_detail_modal"
      : payload?.type;
  const [ensureAll] = useServiceChecker();
  const categoryMapper = useCategories();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const popupRef = useRef(null);
  const archiveActionInFlightRef = useRef(false);
  const recipientConfirmInFlightRef = useRef(false);
  const [showLoader, setShowLoader] = useState(false);
  const [clickedBtn, setClickedBtn] = useState(null);
  const [associatePending] = useState("");
  const [showPopupReject, setshowPopupReject] = useState(false);
  const [RequestRejectAll, setRequestRejectAll] = useState(false);
  const [associateType, setAssociateType] = useState("");
  const [archiveType, setArchiveType] = useState("");
  const [archiveloader, setArchiveLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const [isArchiveActionSubmitting, setIsArchiveActionSubmitting] =
    useState(false);
  const pathName = location?.state?.from ? location?.state?.from : "";
  const txn_single_appr = location?.state?.type ? location?.state?.type : "";

  const [selectedChipIndex, setSelectedChipIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  //useSelector

  const {
    getSpecificFieldForceAccountData,
    getSpecificFieldForceAccountLoading,
  } = useSelector((state) => state.fieldForceAccount);

  const { fieldForceTxnViewAllData } = useSelector(
    (state) => state?.fieldForceTransaction,
  );

  const {
    allFieldForceRequestTransactionsData,
    allFieldForceRequestTransactionsLoading,
  } = useSelector((state) => state.fieldForceRequest);

  const viewAccountDetailData = useMemo(() => {
    if (!getSpecificFieldForceAccountData) return null;
    return {
      ...getSpecificFieldForceAccountData,
      field_force_accounts:
        getSpecificFieldForceAccountData.field_force_accounts ?? [],
    };
  }, [getSpecificFieldForceAccountData]);

  const services = useSelector((state) => state.refreshToken.services);

  const sliceCategory = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  const { beneLookData } = useSelector((state) => state.verify);

  const bankData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration?.mobileScreen,
  );
  const [showCategories, setShowCategories] = useState(
    payload?.showCategory ?? false,
  );
  const [showContactDetails, setShowContactDetails] = useState(
    payload?.showCategory ? false : true,
  );
  const [openfieldForceAssociate, setOpenfieldForceAssociate] = useState(false);
  const [unachivedOpenPop, setUnachivedOpenPop] = useState(false);
  const [achivedOpenPop, setAchivedOpenPop] = useState(false);
  const [ViewAccountDetails, SetViewAccountDetails] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showGstPopup, setGstShowPopup] = useState(false);
  const [showPanPopup, setPanShowPopup] = useState(false);
  const [showIfscPopup, setIfscShowPopup] = useState(false);
  const [deniedId, SetdeniedId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openTransHistory, setOpenTransHistory] = useState(false);
  const [openRequestHistory, setOpenRequestHistory] = useState(false);
  const [nameArchive, setNameArchive] = useState("");
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [userpopup, setUserpopup] = useState(false);
  const [userid, setUserid] = useState("");
  const serviceCheckUser = JSON.parse(sessionStorage.getItem("response"))
    ?.employees?.id;

  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    name: "",
    bank_name: "",
    ifsc_code: "",
    bank_acc_no: "",
    category: "",
    id: "",
    pan: "",
    bank_account_holder_full_name: "",
  });
  const [openBeneAssociate, setOpenBeneAssociate] = useState(false);
  const [showRejectTnxPopup, setRejectTxnPopup] = useState(false);
  const [showScheduleTxnPopup, setShowScheduleTxnPopup] = useState(false);
  const [preventMultiEnter, setPreventMultiEnter] = useState(false);
  const [showAssignedLabels, setShowAssignedLabels] = useState(false);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labels, setLabels] = useState([]);
  const [labelLoading, setLabelLoading] = useState(false);
  const [labelDetails, setLabelDetails] = useState([]);
  const [showAdditionalRecipient, setShowAdditionalRecipient] = useState([]);
  const [showAdditionalSection, setShowAdditionalSection] = useState(false);
  const [additionalRecipient, setAdditionalRecipicent] = useState(false);
  const [additionalSupport, setAdditionalSupport] = useState(false);
  const [tooltip, setTooltip] = useState("Copy to clipboard");
  const [recipients, setRecipients] = useState([]);
  const [recipientButtonDisabled, setRecipientButtonDisabled] = useState(true);
  const [additionalChip, setAdditionalChip] = useState(showAdditionalRecipient);
  const [declineReason, setDeclineReason] = useState("");
  const [activeType, setActiveType] = useState("pan");
  const [fieldForcePan, setFieldForcePan] = useState("");
  const [fieldForceAccount, setFieldForceAccount] = useState("");
  const [fieldForceIFSC, setFieldForceIFSC] = useState("");
  const Navigate = useNavigate();
  let label;

  const copyTextRef = useRef(null);
  const handleSupportIdCopy = async () => {
    const webhookUrl =
      getSpecificFieldForceAccountData?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ]?.id;

    try {
      await navigator.clipboard.writeText(webhookUrl);
      setTooltip("Copied");

      clearTimeout(copyTextRef.current);

      copyTextRef.current = setTimeout(() => {
        setTooltip("Copy to clipboard");
      }, IntervalConfiguration.intervalMedium);
    } catch (error) {
      console.error(error);
    }
  };

  const isUppercaseLabel = (value) => {
    if (typeof value !== "string") return false;
    const trimmed = value.trim();
    if (!trimmed) return false;
    return /[A-Z]/.test(trimmed);
  };

  const filterUppercaseLabels = (labelList) =>
    (Array.isArray(labelList) ? labelList : []).filter(
      (labelValue) => !isUppercaseLabel(labelValue),
    );

  const [category, setCategory] = useState("");
  const [bankDetails, setBankDetails] = useState({
    name: "",
    bankAccountNumber: "",
    ifscCode: "",
  });
  const [previousContactDetails, setPreviousContactDetails] = useState({
    legalName: "",
    contact: "",
    email: "",
    gstin: "",
    category: null,
  });

  const [index, setIndex] = useState(
    showContactDetails
      ? GlobalConfiguration?.lengthCheckZero
      : showCategories
        ? GlobalConfiguration?.lengthCheckOne
        : showAssignedLabels
          ? GlobalConfiguration?.lengthCheckTwo
          : additionalRecipient
            ? GlobalConfiguration?.lengthCheckThree
            : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");
  const loadFieldForceDetails = (accountId) =>
    dispatch(getSpecificFieldForceAccount({ id: accountId }));

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  const { beneDeniedApprovalLoading } = useSelector(
    (state) => state.beneAllVerification,
  );
  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.field_force_accounts &&
      viewAccountDetailData.field_force_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { pan_legal_name, contact_no, email_id } =
        viewAccountDetailData.field_force_accounts[
          GlobalConfiguration.lengthCheckZero
        ];
      setPreviousContactDetails({
        legalName: pan_legal_name,
        contact: contact_no,
        email: email_id,

        category: category || null,
      });
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.field_force_accounts &&
      viewAccountDetailData.field_force_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { category } = viewAccountDetailData?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ]?.category_ids
        ?.map((category) => category.category_name)
        .join();

      setCategory(category);
    }
  }, [viewAccountDetailData]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    if (sanitizedValue.length <= GlobalConfiguration.inputMaxLength) {
      setDeclineReason(sanitizedValue);
    }
  };
  const openTransactionHistory = () => {
    setOpenTransHistory(true);
  };
  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.field_force_accounts &&
      viewAccountDetailData.field_force_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { bank_acc_no, name, ifsc_code } =
        viewAccountDetailData.field_force_accounts[
          GlobalConfiguration.lengthCheckZero
        ];
      setBankDetails({
        bankHolderName: name,
        bankAccountNumber: bank_acc_no,
        ifscCode: ifsc_code,
      });
    }
  }, [viewAccountDetailData]);

  function handleChipClick(chipId) {
    if (selectedChipIndex === chipId) {
      setSelectedChipIndex(null);
    } else {
      setSelectedChipIndex(chipId);
    }
    // setSelectedChipIndex(chipId);
  }

  const hasFieldForceEditService =
    services?.includes("FFUAccount") || services?.includes("Admin");
  const hasBankEditService =
    services?.includes("FFUAccount") || services?.includes("Admin");

  const chipsArray = [
    {
      text: "IFSC",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckZero,
      disabled: true,
      hoverOption: "blue",

      bulletPoint: [
        "Contact the Xpentra administrator to change the IFSC detail.",
      ],
    },
    {
      text: "Name, User, Contact number, Email ID",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckOne,
      disabled: !hasFieldForceEditService,
      bulletPoint: [
        "Account will be marked as pending and will require approval.",
        "Pending transactions associated with a pending account cannot be approved.",
        "Only the newly linked user will have access to this account after the change.",
      ],

      hoverOption: "blue",
      onClick: () => {
        if (hasFieldForceEditService) {
          handleChipClick(GlobalConfiguration.lengthCheckOne);
        }
      },
    },
    {
      text: "Categories",
      selected: selectedChipIndex === TimelineConfiguration.barWidthMedium,
      bulletPoint: [
        "Account will be marked as pending and will require approval.",
        "Pending transactions associated with a pending account cannot be approved.",
        "Proceed with caution when assigning all categories to the same account.",
      ],
      disabled: !hasFieldForceEditService,
      onClick: () => {
        if (hasFieldForceEditService) {
          handleChipClick(GlobalConfiguration?.lengthCheckTwo);
        }
      },
      hoverOption: "blue",
    },
    {
      text: "Recipients",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckThree,
      disabled: !hasFieldForceEditService,
      bulletPoint: [
        "Account will be marked as pending and will require approval.",
        "Pending transactions associated with a pending account cannot be approved.",
        "Account notifications will be sent to added recipients.",
      ],
      onClick: () => {
        if (hasFieldForceEditService) {
          handleChipClick(GlobalConfiguration?.lengthCheckThree);
        }
      },
      hoverOption: "blue",
    },
    {
      text: "PAN, GST number",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckFour,
      bulletPoint: [
        "Account will be marked as pending and will require approval.",
        "Pending transactions associated with a pending account cannot be approved.",
        "If GST was entered during creation, it is required during editing.",
      ],
      disabled: !hasFieldForceEditService,
      onClick: () => {
        if (hasFieldForceEditService) {
          handleChipClick(GlobalConfiguration?.lengthCheckFour);
        }
      },
      hoverOption: "blue",
    },
    {
      text: "Bank account number",
      bulletPoint: [
        "It will be created as a new beneficiary account and archive the old account.",
        "New beneficiary account will remain pending and will require approval.",
        "Pending transactions associated with this account must be rejected.",
      ],
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckFive,
      disabled: !hasBankEditService,
      onClick: () => {
        if (hasBankEditService) {
          handleChipClick(GlobalConfiguration?.lengthCheckFive);
        }
      },
      hoverOption: "blue",
    },
  ];

  const handleApply = () => {
    // dispatch(resetServices());

    dispatch(resetUpdateBeneficiaryAccount());
    dispatch(resetBeneficiaryBankUpdate());

    switch (selectedChipIndex) {
      case GlobalConfiguration.lengthCheckZero: // 0: IFSC Code
        break;

      case GlobalConfiguration.lengthCheckOne: // 1: Account name, Contact number, Email
        if (!hasFieldForceEditService) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "FFUAccount" },
          });
          return;
        }
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/account_details/${id}`,
          {
            state: previousContactDetails,
          },
        );
        handleEditModalClose();
        break;

      case GlobalConfiguration.lengthCheckTwo: // 2: Assigned categories
        if (!hasFieldForceEditService) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "FFUAccount" },
          });
          return;
        }
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_categories/${id}`,
          {
            state: previousContactDetails,
          },
        );
        handleEditModalClose();
        break;

      case GlobalConfiguration.lengthCheckThree: // 3: Recipients
        if (!hasFieldForceEditService) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "FFUAccount" },
          });
          return;
        }

        handleEditModalClose();
        setShowAdditionalSection(true);
        setAdditionalChip(showAdditionalRecipient);
        break;

      case GlobalConfiguration.lengthCheckFour: // 4: PAN Number, GST
        if (!hasFieldForceEditService) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "FFUAccount" },
          });
          return;
        }
        dispatch(resetInEdit());
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_PAN_details/${id}`,
        );
        handleEditModalClose();
        break;

      case GlobalConfiguration.lengthCheckFive: // 5: Bank account number
        if (!hasBankEditService) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "FFUAccount" },
          });
          return;
        }
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_bank_details/${id}`,
          {
            state: bankDetails,
          },
        );
        dispatch(resetBeneficiaryBankUpdate());
        handleEditModalClose();
        break;

      default:
        break;
    }
  };

  const handleModalOpen = (editId) => {
    setIsEditModalOpen(editId);
  };

  const handleEditModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedChipIndex(null);
  };

  const handleAccRejectAlert = () => {
    setRejectTxnPopup(false);
    setshowPopupReject(true);
  };

  // const handleConfirmDecline = async (id, AccountIdData) => {
  //   setShowLoader(true);

  //   UniversalRefreshToast("accountsRefresh");

  //   if (!beneDeniedApprovalLoading || beneDeniedApprovalLoading === null) {
  //     const data = await dispatch(
  //       filedForceDeniedAccount({ id, AccountIdData }),
  //     );
  //     if (
  //       data?.payload?.errors?.user_unauthorized?.length >
  //       GlobalConfiguration?.lengthCheckZero
  //     ) {
  //       Navigate("/feature_not_assigned", {
  //         state: {
  //           unavailableService: "FFAAccount",
  //         },
  //       });
  //       return;
  //     }

  //     setShowLoader(true);

  //     await new Promise((resolve) => {
  //       setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
  //     });

  //     if (data?.payload?.status === false || data?.payload === undefined) {
  //       let error_msg = "";
  //       let error_list = null;
  //       if (data?.payload === undefined) {
  //         error_msg = "An error occured while taking action on this account";
  //       } else if (
  //         data?.payload?.errors?.field_force_accounts ||
  //         data?.payload?.errors?.field_force_account
  //       ) {
  //         const accountErrors =
  //           data?.payload?.errors?.field_force_accounts ||
  //           data?.payload?.errors?.field_force_account;

  //         if (
  //           Array.isArray(accountErrors) &&
  //           accountErrors.length > GlobalConfiguration?.lengthCheckZero
  //         ) {
  //           error_list = accountErrors;
  //           error_msg = accountErrors[GlobalConfiguration.lengthCheckZero];
  //         } else if (typeof accountErrors === "string") {
  //           error_msg = accountErrors;
  //         } else {
  //           error_msg = "An error occured while taking action on this account";
  //         }
  //       } else if (data?.payload?.status === false) {
  //         error_msg =
  //           data?.payload?.errors?.category?.[
  //             GlobalConfiguration.lengthCheckZero
  //           ];
  //       } else if (
  //         data?.payload?.errors?.bank_account_number?.[
  //           GlobalConfiguration.lengthCheckZero
  //         ]
  //       ) {
  //         error_msg =
  //           data?.payload?.errors?.bank_account_number[
  //             GlobalConfiguration.lengthCheckZero
  //           ];
  //       }

  //       if (error_msg === "Field force account already rejected") {
  //         const newData = await loadFieldForceDetails(id);
  //         const updatedFieldForceAccount = {
  //           ...newData?.payload?.field_force_accounts?.[
  //             GlobalConfiguration.lengthCheckZero
  //           ],
  //           error_msg,
  //           error: data?.payload?.status === false ? true : false,
  //         };

  //         const updatedData = ViewAccountDetails?.map((item) => {
  //           if (item.id === id) {
  //             return {
  //               ...item,
  //               ...(updatedFieldForceAccount || {}),
  //             };
  //           }
  //           return item;
  //         });
  //         updateAllAccounts(updatedData);

  //         if (payload?.type === "field_force_account_detail_modal") {
  //           syncAccountToApprovalList(
  //             id,
  //             (item) => mapRejectListItemForSync(item, data, AccountIdData),
  //             { type: "reject", data, accountIdData: AccountIdData },
  //           );
  //         }
  //       } else {
  //         const updatedData = ViewAccountDetails?.map((item) => {
  //           if (item.id === id) {
  //             return {
  //               ...item,
  //               error_msg,
  //               error: data?.payload?.status === false ? true : false,
  //             };
  //           }
  //           return item;
  //         });
  //         updateAllAccounts(updatedData);

  //         if (payload?.type === "field_force_account_detail_modal") {
  //           syncAccountToApprovalList(
  //             id,
  //             (item) => mapRejectListItemForSync(item, data, AccountIdData),
  //             { type: "reject", data, accountIdData: AccountIdData },
  //           );
  //         }
  //       }
  //       setShowLoader(false);
  //       setDeclineReason("");
  //       handleClosePopup();
  //       if (
  //         Array.isArray(error_list) &&
  //         error_list.length > GlobalConfiguration?.lengthCheckOne
  //       ) {
  //         error_list.forEach((err) => {
  //           setTimeout(() => {
  //             CommonToast({
  //               text: err,
  //               icon: ICONS?.INFO_FILLED,
  //               variant: "var(--error)",
  //               buttonNeeded: false,
  //             });
  //           }, IntervalConfiguration?.intervalSmall);
  //         });
  //       } else {
  //         CommonToast({
  //           text: error_msg,
  //           icon: ICONS?.INFO_FILLED,
  //           variant: "var(--error)",
  //           buttonNeeded: false,
  //         });
  //       }
  //     } else {
  //       const updatedData = ViewAccountDetails?.map((item) => {
  //         if (item.id === id) {
  //           return {
  //             ...item,
  //             approval_status:
  //               item.approval_status === "pending" ? "rejected" : "pending",

  //             rejected_on:
  //               data?.payload?.status === true
  //                 ? data?.payload?.field_force_accounts?.[
  //                     GlobalConfiguration.lengthCheckZero
  //                   ]?.rejected_on
  //                 : "",
  //             rejected_by_name:
  //               data?.payload?.status === true
  //                 ? data?.payload?.field_force_accounts?.[
  //                     GlobalConfiguration.lengthCheckZero
  //                   ]?.rejected_by_name
  //                 : "",
  //             rejection_reason: AccountIdData,
  //             error:
  //               item.error === false && data?.payload?.status === false
  //                 ? true
  //                 : false,
  //             message:
  //               item.message === "" && data?.payload?.status === false
  //                 ? data?.payload?.errors?.field_force_accounts?.[
  //                     GlobalConfiguration.lengthCheckZero
  //                   ]
  //                 : "",
  //           };
  //         }
  //         return item;
  //       });
  //       updateAllAccounts(updatedData);
  //       setShowLoader(false);
  //       setDeclineReason("");
  //       handleClosePopup();
  //       toast.dismiss();
  //       CommonToast({
  //         text: "Field force account rejected successfully",
  //         icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
  //         variant: "var(--success)",
  //         buttonNeeded: false,
  //       });
  //       if (onSuccess) {
  //         onSuccess();
  //       }
  //       if (payload?.type === "field_force_account_detail_modal") {
  //         syncAccountToApprovalList(
  //           id,
  //           (item) => mapRejectListItemForSync(item, data, AccountIdData),
  //           { type: "reject", data, accountIdData: AccountIdData },
  //         );
  //         setTimeout(() => {
  //           payload?.closeBeneAccountDetailModal();
  //         }, IntervalConfiguration.intervalExtraLarge);
  //       }
  //       if (pathName) {
  //         setTimeout(() => {
  //           Navigate(pathName);
  //         }, IntervalConfiguration.intervalExtraLarge);
  //       }
  //     }
  //   }
  // };

  const handleRejectAllTransaction = async () => {
    setShowLoader(true); // Ensure loader is active during process

    const reasonPayload = declineReason;
    const targetedId = id || fieldForceAccountId;

    let linkedTxnIds = [];
    if (
      fieldForceTxnViewAllData?.transactions?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      linkedTxnIds = fieldForceTxnViewAllData.transactions.map(
        (tx) => tx?.txn_id,
      );
    }

    UniversalRefreshToast("Rejecting transactions.");

    if (linkedTxnIds.length > GlobalConfiguration.lengthCheckZero) {
      const txnResponse = await dispatch(
        FieldForceMultiTxnDeniedApproval({
          id: linkedTxnIds,
          AccountIdData: reasonPayload,
        }),
      );

      if (txnResponse?.payload?.status === true) {
        setRejectTxnPopup(false);
        toast.dismiss();

        if (typeof payload?.setAllAccounts === "function") {
          payload.setAllAccounts((prevAccounts) => {
            if (!Array.isArray(prevAccounts)) return [];
            return prevAccounts.filter(
              (txn) => !linkedTxnIds.includes(txn.txn_id),
            );
          });
        }

        const detailsResponse = await dispatch(
          getSpecificFieldForceAccount({ id: targetedId }),
        );
        const refreshedAccount =
          detailsResponse?.payload?.field_force_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ];

        if (refreshedAccount?.pending_field_force_requests === "Y") {
          if (archiveType === "archive") {
            setArchiveType("Requestarchive");
          }
          setRequestRejectAll(true);
          setShowLoader(false);
        } else if (refreshedAccount?.pending_field_force_transactions === "Y") {
          setRejectTxnPopup(true);
          setShowLoader(false);
        } else {
          setTimeout(() => {
            if (associateType === "archiveAccount") {
              archiveAccount(targetedId);
            } else {
              handleConfirmDecline(targetedId, reasonPayload);
            }
          }, IntervalConfiguration?.intervalSmall);
        }

        setTimeout(() => {
          toast.dismiss();
          CommonToast({
            text: "Associated transactions rejected successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
            buttonNeeded: false,
          });
        }, IntervalConfiguration?.intervalSmall);
      } else {
        const errorMsg =
          txnResponse?.payload?.errors?.base?.[0] ||
          "Failed to batch reject field force transactions.";
        CommonToast({
          text: errorMsg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setShowLoader(false);
      }
    } else {
      const detailsResponse = await dispatch(
        getSpecificFieldForceAccount({ id: targetedId }),
      );
      const refreshedAccount =
        detailsResponse?.payload?.field_force_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ];

      if (refreshedAccount?.pending_field_force_requests === "Y") {
        setRequestRejectAll(true);
      } else if (refreshedAccount?.pending_field_force_transactions === "Y") {
        setRejectTxnPopup(true);
      } else if (associateType === "archiveAccount") {
        archiveAccount(targetedId);
      } else {
        handleConfirmDecline(targetedId, reasonPayload);
      }
      setShowLoader(false);
    }
  };

  const handleConfirmAlert = async (transactions) => {
    try {
      const AccountIdData = declineReason;

      const ids = transactions?.map((t) => t.txn_id) || [];

      UniversalRefreshToast("Rejecting transaction");

      if (ids.length > GlobalConfiguration?.lengthCheckZero) {
        const data = await dispatch(
          beneTxnMultiDeniedApproval({ id: ids, AccountIdData }),
        );

        if (data?.payload?.status === true) {
          // 🟢 REMOVE REJECTED TRANSACTIONS FROM PARENT LIST
          if (typeof payload?.setAllAccounts === "function") {
            payload.setAllAccounts((prevAccounts) => {
              if (!Array.isArray(prevAccounts)) return [];
              return prevAccounts.filter((txn) => !ids.includes(txn.txn_id));
            });
          }

          toast.dismiss();
          CommonToast({
            text: "Transaction(s) rejected successfully",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--positive-toast)",
            buttonNeeded: false,
          });
          setDeclineReason("");
        }
      }
      await loadFieldForceDetails(id);
      setDeclineReason("");
    } catch (error) {
      CommonToast({
        text: "Something went wrong. Please try again",
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const handleConfirmDecline = async (id, AccountIdData) => {
    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    if (!beneDeniedApprovalLoading || beneDeniedApprovalLoading === null) {
      const data = await dispatch(
        filedForceDeniedAccount({ id, AccountIdData }),
      );
      if (
        data?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration?.lengthCheckZero
      ) {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "FFAAccount",
          },
        });
        return;
      }

      setShowLoader(true);

      await new Promise((resolve) => {
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
      });

      if (data?.payload?.status === false || data?.payload === undefined) {
        let error_msg = "";
        let error_list = null;
        if (data?.payload === undefined) {
          error_msg = "An error occured while taking action on this account";
        } else if (
          data?.payload?.errors?.field_force_accounts ||
          data?.payload?.errors?.field_force_account
        ) {
          const accountErrors =
            data?.payload?.errors?.field_force_accounts ||
            data?.payload?.errors?.field_force_account;

          if (
            Array.isArray(accountErrors) &&
            accountErrors.length > GlobalConfiguration?.lengthCheckZero
          ) {
            error_list = accountErrors;
            error_msg = accountErrors[GlobalConfiguration.lengthCheckZero];
          } else if (typeof accountErrors === "string") {
            error_msg = accountErrors;
          } else {
            error_msg = "An error occured while taking action on this account";
          }
        } else if (data?.payload?.status === false) {
          error_msg =
            data?.payload?.errors?.category?.[
              GlobalConfiguration.lengthCheckZero
            ];
        } else if (
          data?.payload?.errors?.bank_account_number?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          error_msg =
            data?.payload?.errors?.bank_account_number[
              GlobalConfiguration.lengthCheckZero
            ];
        }

        if (error_msg === "Field force account already rejected") {
          const newData = await loadFieldForceDetails(id);
          const updatedFieldForceAccount = {
            ...newData?.payload?.field_force_accounts?.[
              GlobalConfiguration.lengthCheckZero
            ],
            error_msg,
            error: data?.payload?.status === false ? true : false,
          };

          const updatedData = ViewAccountDetails?.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                ...(updatedFieldForceAccount || {}),
              };
            }
            return item;
          });
          updateAllAccounts(updatedData);

          if (payload?.type === "field_force_account_detail_modal") {
            syncAccountToApprovalList(
              id,
              (item) => mapRejectListItemForSync(item, data, AccountIdData),
              { type: "reject", data, accountIdData: AccountIdData },
            );
          }
        } else {
          const updatedData = ViewAccountDetails?.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                error_msg,
                error: data?.payload?.status === false ? true : false,
              };
            }
            return item;
          });
          updateAllAccounts(updatedData);

          if (payload?.type === "field_force_account_detail_modal") {
            syncAccountToApprovalList(
              id,
              (item) => mapRejectListItemForSync(item, data, AccountIdData),
              { type: "reject", data, accountIdData: AccountIdData },
            );
          }
        }
        setShowLoader(false);
        setDeclineReason("");
        handleClosePopup();
        if (
          Array.isArray(error_list) &&
          error_list.length > GlobalConfiguration?.lengthCheckOne
        ) {
          error_list.forEach((err) => {
            setTimeout(() => {
              CommonToast({
                text: err,
                icon: ICONS?.INFO_FILLED,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            }, IntervalConfiguration?.intervalSmall);
          });
        } else {
          CommonToast({
            text: error_msg,
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      } else {
        const updatedData = ViewAccountDetails?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "rejected" : "pending",

              rejected_on:
                data?.payload?.status === true
                  ? data?.payload?.field_force_accounts?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.rejected_on
                  : "",
              rejected_by_name:
                data?.payload?.status === true
                  ? data?.payload?.field_force_accounts?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.rejected_by_name
                  : "",
              rejection_reason: AccountIdData,
              error:
                item.error === false && data?.payload?.status === false
                  ? true
                  : false,
              message:
                item.message === "" && data?.payload?.status === false
                  ? data?.payload?.errors?.field_force_accounts?.[
                      GlobalConfiguration.lengthCheckZero
                    ]
                  : "",
            };
          }
          return item;
        });
        updateAllAccounts(updatedData);

        // 🟢 REMOVE TRANSACTIONS OF THIS REJECTED ACCOUNT FROM PARENT LIST
        if (typeof payload?.setAllAccounts === "function") {
          payload.setAllAccounts((prevAccounts) => {
            if (!Array.isArray(prevAccounts)) return [];
            return prevAccounts.filter(
              (acc) =>
                String(acc.field_force_account_id) !== String(id) &&
                String(acc.id) !== String(id),
            );
          });
        }

        setShowLoader(false);
        setDeclineReason("");
        handleClosePopup();
        toast.dismiss();
        CommonToast({
          text: "Field force account rejected successfully",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
        if (onSuccess) {
          onSuccess();
        }
        if (payload?.type === "field_force_account_detail_modal") {
          syncAccountToApprovalList(
            id,
            (item) => mapRejectListItemForSync(item, data, AccountIdData),
            { type: "reject", data, accountIdData: AccountIdData },
          );
          setTimeout(() => {
            payload?.closeBeneAccountDetailModal();
          }, IntervalConfiguration.intervalExtraLarge);
        }
        if (pathName) {
          setTimeout(() => {
            Navigate(pathName);
          }, IntervalConfiguration.intervalExtraLarge);
        }
      }
    }
  };

  async function fetchData() {
    if (showLabelsPopup) {
      setLoading(false);
    } else {
      setLoading(true);
    }
    try {
      let response;
      if (payload?.type === "field_force_account_detail_modal") {
        response = await loadFieldForceDetails(fieldForceAccountId);
      } else {
        response = await loadFieldForceDetails(id);
      }

      if (getSpecificFieldForceAccount.rejected.match(response)) {
        return;
      }

      if (payload?.type === "field_force_account_detail_modal") {
        setLabelDetails(
          response?.payload?.field_force_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ]?.labels || [],
        );
      } else {
        setLabelDetails(
          response?.payload?.field_force_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ]?.labels || [],
        );
        setShowAdditionalRecipient(
          response?.payload?.field_force_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ]?.recipient_email || [],
        );
        setAdditionalChip(
          response?.payload?.field_force_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ]?.recipient_email || [],
        );
      }
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("/*");
      }
    } catch (error) {
      console.error("Failed to load the account details", error);
    } finally {
      setLoading(false);
    }
  }
  const finalRecipients = [...new Set([...recipients, ...additionalChip])];

  const handleConfirm = async () => {
    if (
      recipientButtonDisabled ||
      recipientConfirmInFlightRef.current ||
      editFieldForceAccountLoading
    ) {
      return;
    }
    setButtonLoader(true);
    recipientConfirmInFlightRef.current = true;

    try {
      const previousRecipients = showAdditionalRecipient;
      const nextRecipients = [...new Set([...recipients, ...additionalChip])];

      const isRemoving =
        previousRecipients.length > nextRecipients.length ||
        (nextRecipients.length === 0 && previousRecipients.length > 0);

      CommonToast({
        text: isRemoving ? "Removing recipient." : "Adding recipient.",
        icon: ICONS?.LOADER_GIF,
        variant: "var(--processing)",
        buttonNeeded: false,
      });

      const recipientString = nextRecipients.join(",");
      const targetAccountId = currentAccountDetails?.id || id;
      const primaryFieldForceAccount =
        viewAccountDetailData?.field_force_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ];
      const linkedUserId =
        primaryFieldForceAccount?.linked_user_id ||
        primaryFieldForceAccount?.field_force_user_id;

      let response = await dispatch(
        editFieldForceAccount({
          id: targetAccountId,
          recipient_email: recipientString,
          linked_user_id: linkedUserId,
        }),
      );

      await new Promise((resolve) =>
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
      );

      toast.dismiss();

      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: isRemoving
            ? "Recipient removed successfully"
            : "Recipient added successfully",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
        setShowAdditionalSection(false);
        await fetchData();
        setRecipients([]);
      } else {
        CommonToast({
          text: isRemoving
            ? "Failed to remove recipient."
            : "Failed to add recipient.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setShowAdditionalSection(false);
      }
    } finally {
      recipientConfirmInFlightRef.current = false;
      setButtonLoader(false);
    }
  };

  const handleClose = () => {
    setShowLabelsPopup(false);
    fetchData();
  };
  const handlePANDetails = async (pan) => {
    if (pan?.length === GlobalConfiguration?.panLength) {
      const response = await dispatch(
        beneVerifyThisPAN({ search_string: pan }),
      );
      if (response?.payload?.status === true) {
        setPanShowPopup(true);
      } else if (
        response?.payload?.errors?.user_unauthorized?.[
          GlobalConfiguration.lengthCheckZero
        ]
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "FFUAccount",
          },
        });
      } else if (response?.payload?.status === false) {
        CommonToast({
          text: `${response?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]}`,
          icon: ICONS?.INFO_FILLED,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload?.response?.data?.ids?.unsuccessful_ids?.[
        GlobalConfiguration.lengthCheckZero
      ]?.errors || res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[GlobalConfiguration.lengthCheckZero]) {
      const base = p.errors.base[GlobalConfiguration.lengthCheckZero];
      return typeof base === "string"
        ? base
        : base?.errors?.[GlobalConfiguration.lengthCheckZero] ||
            base?.message ||
            "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const res = await dispatch(
      addFieldForceAccNewLabel({
        record_ids: toArray(id),
        labels: labelsToAssign,
      }),
    );

    if (addFieldForceAccNewLabel.fulfilled.match(res)) {
      fetchData();
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    if (addFieldForceAccNewLabel.rejected.match(res)) {
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLabelLoading(false);
    if (addFieldForceAccNewLabel.fulfilled.match(res)) {
      return true;
    }
    return false;
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const res = await dispatch(
      removeFieldForceAccNewLabel({
        record_ids: toArray(id),
        labels: labelsToUnassign,
      }),
    );

    if (removeFieldForceAccNewLabel.fulfilled.match(res)) {
      fetchData();
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    if (removeFieldForceAccNewLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLabelLoading(false);
    if (removeFieldForceAccNewLabel.fulfilled.match(res)) {
      return true;
    }
    return false;
  };

  const isArchived =
    viewAccountDetailData?.field_force_accounts[
      GlobalConfiguration.lengthCheckZero
    ]?.approval_status === "archived";

  const hasALabel = services?.includes("ALabel");
  const hasRLabel = services?.includes("RLabel");

  const isServiceMissing = !(hasALabel && hasRLabel);

  const handleClick = () => {
    if (isArchived) return;

    if (isServiceMissing) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "ALabel,RLabel" },
      });
    } else {
      setShowLabelsPopup(true);
    }
  };

  if (
    payload.internalAccount === "internalAccount" &&
    services?.find(
      (service) => service === "FFAAccountArchive" || service === "Admin",
    ) === undefined &&
    viewAccountDetailData?.field_force_accounts[
      GlobalConfiguration.lengthCheckZero
    ]?.approval_status === "archived"
  ) {
    label = (
      <>
        Unarchive <br /> account{" "}
      </>
    );
  } else if (payload.internalAccount === "internalAccount") {
    label = (
      <>
        Archive <br /> account{" "}
      </>
    );
  } else if (
    services?.find(
      (service) => service === "FFAAccountArchive" || service === "Admin",
    ) === undefined &&
    viewAccountDetailData?.field_force_accounts[
      GlobalConfiguration.lengthCheckZero
    ]?.approval_status === "archived"
  ) {
    label = (
      <>
        Unarchive <br /> account{" "}
      </>
    );
  } else {
    label = (
      <>
        Archive <br /> account{" "}
      </>
    );
  }

  const handleCloseModal = () => {
    setArchiveType("");
    setAssociateType("");
    setDeclineReason("");
    setArchiveLoader(false);
    setOpenfieldForceAssociate(false);
    setActiveType("Pan");
    setFieldForcePan(viewAccountDetailData?.field_force_accounts[0]?.pan_no);
    setFieldForceIFSC("");
    setFieldForceAccount("");
    setAchivedOpenPop(false);
    setUnachivedOpenPop(false);
  };
  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${fieldForceAccountId}`,
    });
  };

  const handleEditAccountClick = (defaultChipIndex = null) => {
    dispatch(resetEditFieldForceAccountData());
    handleModalOpen(id);
    if (defaultChipIndex !== null) {
      setSelectedChipIndex(defaultChipIndex);
    }
  };

  const handleAssociatedAccountsClick = () => {
    setActiveType("Pan");
    if (payload.type === "field_force_account_detail_modal") {
      actionRestricted();
      return;
    }
    setOpenfieldForceAssociate(true);
    setFieldForcePan(viewAccountDetailData?.field_force_accounts[0]?.pan_no);
  };

  const hasArchiveServiceAccess =
    services?.find(
      (service) => service === "FFAAccountArchive" || service === "Admin",
    ) !== undefined;

  const handleArchiveReject = () => {
    setAchivedOpenPop(false);
    setshowPopupReject(true);
  };
  const handleUnarchive = () => {
    setUnachivedOpenPop(true);
    if (viewAccountDetailData?.field_force_accounts?.[0]?.archived === "N") {
      setUnachivedOpenPop(false);
    } else {
      setUnachivedOpenPop(true);
    }
  };
  const handleArchive = () => {
    if (viewAccountDetailData?.field_force_accounts?.[0]?.archived === "N") {
      setAchivedOpenPop(true);
    } else {
      setAchivedOpenPop(false);
    }
  };

  const toggleCategories = () => {
    setShowCategories(true);
    setShowContactDetails(false);
    setShowAssignedLabels(false);
    setAdditionalRecipicent(false);
    setAdditionalSupport(false);
    setIndex(GlobalConfiguration.lengthCheckOne);
  };
  const toggleContactDetails = () => {
    setShowContactDetails(true);
    setShowCategories(false);
    setShowAssignedLabels(false);
    setAdditionalRecipicent(false);
    setAdditionalSupport(false);
    setIndex(GlobalConfiguration.lengthCheckZero);
  };

  const toggleAssignedLabels = () => {
    setShowAssignedLabels(true);
    setShowCategories(false);
    setShowContactDetails(false);
    setAdditionalRecipicent(false);
    setAdditionalSupport(false);
    setIndex(GlobalConfiguration.lengthCheckTwo);
  };

  const toggleAdditionalRecipicent = () => {
    setAdditionalRecipicent(true);
    setShowAssignedLabels(false);
    setShowCategories(false);
    setShowContactDetails(false);
    setAdditionalSupport(false);
    setIndex(GlobalConfiguration.lengthCheckThree);
  };

  const toggleSupportDetails = () => {
    setAdditionalSupport(true);
    setAdditionalRecipicent(false);
    setShowAssignedLabels(false);
    setShowCategories(false);
    setShowContactDetails(false);
    setIndex(GlobalConfiguration.lengthCheckFour);
  };

  const closeTransactionHistory = () => {
    setOpenTransHistory(false);
  };

  const closeRequestHistory = () => {
    setOpenRequestHistory(false);
  };

  const handleTransactionHistoryClick = () => {
    if (payload.type === "field_force_account_detail_modal") {
      actionRestricted();
      return;
    }
    openTransactionHistory();
  };

  const handleRequestHistoryClick = () => {
    if (payload.type === "field_force_account_detail_modal") {
      actionRestricted();
      return;
    }
    setOpenRequestHistory(true);
  };

  // const handleRejectAllTransaction = async () => {
  //   setShowLoader(true); // Ensure loader is active during process

  //   const reasonPayload = declineReason;
  //   const targetedId = id || fieldForceAccountId;

  //   let linkedTxnIds = [];
  //   if (
  //     fieldForceTxnViewAllData?.transactions?.length >
  //     GlobalConfiguration.lengthCheckZero
  //   ) {
  //     linkedTxnIds = fieldForceTxnViewAllData.transactions.map(
  //       (tx) => tx?.txn_id,
  //     );
  //   }

  //   UniversalRefreshToast("Rejecting transactions.");

  //   if (linkedTxnIds.length > GlobalConfiguration.lengthCheckZero) {
  //     const txnResponse = await dispatch(
  //       FieldForceMultiTxnDeniedApproval({
  //         id: linkedTxnIds,
  //         AccountIdData: reasonPayload,
  //       }),
  //     );

  //     if (txnResponse?.payload?.status === true) {
  //       setRejectTxnPopup(false);
  //       toast.dismiss();

  //       if (
  //         viewAccountDetailData?.field_force_accounts?.[0]
  //           ?.pending_field_force_requests === "Y"
  //       ) {
  //         if (archiveType === "archive") {
  //           setArchiveType("Requestarchive");
  //         }
  //         setRequestRejectAll(true);
  //         setShowLoader(false);
  //       } else {
  //         setTimeout(() => {
  //           if (associateType === "archiveAccount") {
  //             archiveAccount(targetedId);
  //           } else {
  //             handleConfirmDecline(targetedId, reasonPayload);
  //           }
  //         }, IntervalConfiguration?.intervalSmall);
  //       }

  //       setTimeout(() => {
  //         toast.dismiss();
  //         CommonToast({
  //           text: "Associated transactions rejected successfully.",
  //           icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
  //           variant: "var(--success)",
  //           buttonNeeded: false,
  //         });
  //       }, IntervalConfiguration?.intervalSmall);
  //     } else {
  //       const errorMsg =
  //         txnResponse?.payload?.errors?.base?.[0] ||
  //         "Failed to batch reject field force transactions.";
  //       CommonToast({
  //         text: errorMsg,
  //         icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
  //         variant: "var(--error)",
  //         buttonNeeded: false,
  //       });
  //       setShowLoader(false);
  //     }
  //   } else {
  //     if (
  //       viewAccountDetailData?.field_force_accounts?.[0]
  //         ?.pending_field_force_requests === "Y"
  //     ) {
  //       setRequestRejectAll(true);
  //     } else if (associateType === "archiveAccount") {
  //       archiveAccount(targetedId);
  //     } else {
  //       handleConfirmDecline(targetedId, reasonPayload);
  //     }
  //     setShowLoader(false);
  //   }
  // };

  const handleRejectRequestTxn = async () => {
    setShowLoader(true);
    setshowPopupReject(false);

    const AccountIdData = declineReason;
    const targetedId = id || fieldForceAccountId;
    let id2 = [];

    id2 =
      !allFieldForceRequestTransactionsLoading &&
      allFieldForceRequestTransactionsData?.requests?.length >
        GlobalConfiguration.lengthCheckZero
        ? allFieldForceRequestTransactionsData?.requests?.map(
            (data) => data?.request_id,
          )
        : [];

    UniversalRefreshToast("Rejecting requests");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        fieldforcerequestTxnReject({ request_ids: id2, AccountIdData }),
      );
    } else {
      setShowLoader(false);
      return;
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "AFieldForceRequest";
      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false || data?.payload === undefined) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      setRejectTxnPopup(false);
      setRequestRejectAll(false);
      toast.dismiss();
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: "Requests rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
      }, IntervalConfiguration?.intervalSmall);

      if (associateType === "rejectAccount") {
        handleConfirmDecline(targetedId, AccountIdData);
      } else if (
        archiveType === "Requestarchive" ||
        associateType === "archiveAccount"
      ) {
        await archiveAccount(targetedId);
      }
    }

    setTimeout(() => {
      setRejectTxnPopup(false);
    }, IntervalConfiguration.intervalMedium);

    if (
      associateType !== "rejectAccount" &&
      associateType !== "archiveAccount"
    ) {
      setDeclineReason("");
      setAssociateType("");
    }

    await loadFieldForceDetails(id || fieldForceAccountId);
    setShowLoader(false);
  };

  const handleRejectAlert = async () => {
    setShowLoader(true);

    const queryParams = {
      page_no: GlobalConfiguration.lengthCheckOne,
      page_item_count: PaginationConfiguration.paginationSmall,
      lifecycle_status: "pending",
      beneficiary_account_id: id,
    };

    const response = await dispatch(beneTxnViewAllAcc(queryParams));
    const data = response?.payload?.transactions;

    if (
      data?.length > GlobalConfiguration.lengthCheckZero &&
      response?.payload?.status === true
    ) {
      setShowLoader(false);
      handleConfirmAlert(data);
      setRejectTxnPopup(false);
      setshowPopupReject(false);
    }
  };

  // const handleConfirmAlert = async (transactions) => {
  //   try {
  //     const AccountIdData = declineReason;

  //     const ids = transactions?.map((t) => t.txn_id) || [];

  //     UniversalRefreshToast("Rejecting transaction");

  //     if (ids.length > GlobalConfiguration?.lengthCheckZero) {
  //       const data = await dispatch(
  //         beneTxnMultiDeniedApproval({ id: ids, AccountIdData }),
  //       );

  //       if (data?.payload?.status === true) {
  //         toast.dismiss();
  //         CommonToast({
  //           text: "Transaction(s) rejected successfully",
  //           icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
  //           variant: "var(--positive-toast)",
  //           buttonNeeded: false,
  //         });
  //         setDeclineReason("");
  //       }
  //     }
  //     await loadFieldForceDetails(id);
  //     setDeclineReason("");
  //   } catch (error) {
  //     CommonToast({
  //       text: "Something went wrong. Please try again",
  //       icon: ICONS?.INFO_FILLED,
  //       variant: "var(--error)",
  //       buttonNeeded: false,
  //     });
  //   }
  // };

  const handleRejectChecker = async (accountId, AccountIdData) => {
    setshowPopupReject(false);
    setShowLoader(true);

    const targetedId = fieldForceAccountId || accountId || id;
    const detailsResponse = await dispatch(
      getSpecificFieldForceAccount({ id: targetedId }),
    );
    const primaryAcc =
      detailsResponse?.payload?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];

    if (primaryAcc?.pending_field_force_transactions === "Y") {
      setRejectTxnPopup(true);
      setAssociateType("rejectAccount");
      setShowLoader(false);
      return;
    }

    if (primaryAcc?.pending_field_force_requests === "Y") {
      setAssociateType("rejectAccount");
      setRequestRejectAll(true);
      setShowLoader(false);
      return;
    }

    handleConfirmDecline(targetedId, AccountIdData || declineReason);
  };

  const handleArchiveChecker = async (accountId, AccountIdData) => {
    setshowPopupReject(false);
    setShowLoader(true);

    const targetedId = fieldForceAccountId || accountId || id;
    const detailsResponse = await dispatch(
      getSpecificFieldForceAccount({ id: targetedId }),
    );
    const primaryAcc =
      detailsResponse?.payload?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];

    if (primaryAcc?.pending_field_force_transactions === "Y") {
      setRejectTxnPopup(true);
      setAssociateType("archiveAccount");
      setShowLoader(false);
      handleArchiveRejectTransaction();
      return;
    }

    if (primaryAcc?.pending_field_force_requests === "Y") {
      setAssociateType("archiveAccount");
      setRequestRejectAll(true);
      setShowLoader(false);
      handleRejectRequestTxn();
      return;
    }

    handleConfirmDecline(targetedId, AccountIdData || declineReason);
  };

  const handleLinkedUser = () => {
    if (payload.type === "field_force_account_detail_modal") {
      actionRestricted();
      return;
    }
    const ffAcc =
      viewAccountDetailData?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];
    if (!ffAcc?.field_force_user_full_name) {
      return;
    }

    const hasVSpecificEmp = ensureAll(["VSpecificEmp"])?.status;
    const hasAdmin = ensureAll(["Admin"])?.status;
    const ffUserId = ffAcc?.field_force_user_id || ffAcc?.linked_user_id;

    const canViewLinkedUser =
      (hasVSpecificEmp && ffUserId === serviceCheckUser) ||
      (hasVSpecificEmp && hasAdmin);

    if (canViewLinkedUser && ffUserId) {
      setUserid(ffUserId);
      setUserpopup(true);
      return;
    }

    const unavailableService = !hasVSpecificEmp
      ? "VSpecificEmp"
      : !hasAdmin
        ? "Admin"
        : "VSpecificEmp";

    if (!canViewLinkedUser) {
      navigate("/feature_not_assigned", {
        state: { unavailableService },
      });
    }
  };

  const handleApprovalDetails = async (id) => {
    setShowLoader(true);
    const targetAccountId =
      payload?.type === "field_force_account_detail_modal"
        ? fieldForceAccountId
        : id;
    let response;
    try {
      UniversalRefreshToast("approvalaccountsRefresh");

      response = await dispatch(filedForceApproval(id));

      if (
        response?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration?.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "FFAAccount",
          },
        });
        return;
      }
      if (
        response?.payload?.status === false ||
        response?.payload === undefined
      ) {
        let error_msg = "";
        if (response?.payload === undefined) {
          error_msg = "An error occured while taking action on this account";
        } else if (
          response?.payload?.errors?.field_force_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          error_msg =
            response.payload.errors.field_force_accounts[
              GlobalConfiguration.lengthCheckZero
            ];
        } else if (
          response?.payload?.errors?.bank_account_number?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          error_msg =
            response.payload.errors.bank_account_number[
              GlobalConfiguration.lengthCheckZero
            ];
        } else {
          error_msg = "An unknown error occurred.";
        }
        if (error_msg === "Field force account already approved") {
          const updatedData = viewAccountDetailData?.field_force_accounts.map(
            (item) => {
              if (item.id === targetAccountId) {
                return {
                  ...item,
                  approval_status:
                    item.approval_status === "pending" ? "approved" : "pending",
                };
              }
              return item;
            },
          );
          SetViewAccountDetails(updatedData);

          // 🟢 UPDATE MULTI-PAGE PARENT LIST INSTANTLY
          if (typeof payload?.setAllAccounts === "function") {
            payload.setAllAccounts((prevAccounts) => {
              if (!Array.isArray(prevAccounts)) return [];
              return prevAccounts.map((acc) => {
                if (
                  String(acc.field_force_account_id) ===
                    String(targetAccountId) ||
                  String(acc.id) === String(targetAccountId) ||
                  String(acc.txn_id) === String(targetAccountId)
                ) {
                  return {
                    ...acc,
                    field_force_account_approval_status: "Approved",
                    approval_status: "Approved",
                  };
                }
                return acc;
              });
            });
          }

          if (typeof syncAccountToApprovalList === "function") {
            syncAccountToApprovalList(
              targetAccountId,
              { field_force_account_approval_status: "approved" },
              { type: "approve", data: response },
            );
          }

          if (payload?.type === "field_force_account_detail_modal") {
            syncAccountToApprovalList(
              fieldForceAccountId,
              (item) => mapApprovalListItemForSync(item, response),
              { type: "approve", data: response },
            );
            await loadFieldForceDetails(fieldForceAccountId);
          } else {
            await loadFieldForceDetails(id);
          }
        } else {
          const updatedData = viewAccountDetailData?.field_force_accounts.map(
            (item) => {
              if (item.id === targetAccountId) {
                return {
                  ...item,
                  approval_status:
                    item.approval_status === "pending" ? "pending" : "",
                  error_msg,
                };
              }
              return item;
            },
          );

          SetViewAccountDetails(updatedData);

          if (payload?.type === "field_force_account_detail_modal") {
            syncAccountToApprovalList(
              fieldForceAccountId,
              (item) => mapApprovalListItemForSync(item, response),
              { type: "approve", data: response },
            );
          }
        }
        CommonToast({
          text: error_msg,
          icon: ICONS?.INFO_FILLED,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else {
        const updatedData = viewAccountDetailData?.field_force_accounts.map(
          (item) => {
            if (item.id === targetAccountId) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "approved" : "pending",
              };
            }
            return item;
          },
        );
        SetViewAccountDetails(updatedData);

        // 🟢 UPDATE MULTI-PAGE PARENT LIST INSTANTLY ON SUCCESSFUL APPROVAL
        if (typeof payload?.setAllAccounts === "function") {
          payload.setAllAccounts((prevAccounts) => {
            if (!Array.isArray(prevAccounts)) return [];
            return prevAccounts.map((acc) => {
              if (
                String(acc.field_force_account_id) ===
                  String(targetAccountId) ||
                String(acc.id) === String(targetAccountId) ||
                String(acc.txn_id) === String(targetAccountId)
              ) {
                return {
                  ...acc,
                  field_force_account_approval_status: "Approved",
                  approval_status: "Approved",
                };
              }
              return acc;
            });
          });
        }

        if (typeof syncAccountToApprovalList === "function") {
          syncAccountToApprovalList(
            targetAccountId,
            { field_force_account_approval_status: "approved" },
            { type: "approve", data: response },
          );
        }

        if (payload?.type === "field_force_account_detail_modal") {
          await loadFieldForceDetails(fieldForceAccountId);
        } else {
          await loadFieldForceDetails(id);
        }

        const successMessage = "Field force account approved successfully";
        toast.dismiss();
        CommonToast({
          text: successMessage,
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
        if (onSuccess) {
          onSuccess();
        }
        if (payload?.type === "field_force_account_detail_modal") {
          syncAccountToApprovalList(
            fieldForceAccountId,
            (item) => mapApprovalListItemForSync(item, response),
            { type: "approve", data: response },
          );
          setTimeout(() => {
            payload?.closeBeneAccountDetailModal();
          }, IntervalConfiguration?.intervalSmall);
        }
        if (pathName) {
          setTimeout(() => {
            navigate(pathName);
          }, IntervalConfiguration?.intervalPopup);
        }

        if (txn_single_appr === "txn_single_approval") {
          setTimeout(() => {
            navigate(IntervalConfiguration?.navigate_back);
          }, IntervalConfiguration?.intervalExtraLarger);
        }
      }
    } finally {
      setShowLoader(false);
      setClickedBtn(null);
    }
  };

  const handleDeclinedDetials = (declineId) => {
    setClickedBtn("reject");
    setshowPopupReject(true);
    SetdeniedId(declineId);
  };

  const handlecloseSchedule = () => {
    setShowPopup(false);
  };
  const handleClosePopup = () => {
    setRejectTxnPopup(false);
    setShowPopup(false);
    setRequestRejectAll(false);

    setshowPopupReject(false);
    if (payload?.type !== "field_force_account_detail_modal") {
      setPreventMultiEnter(false);
      if (payload?.type === "scheduleAcc") {
        setShowScheduleTxnPopup(false);
      }
    }
    setDeclineReason("");
    setAssociateType("");
    setArchiveType("");
    setShowLoader(false);
    setClickedBtn(null);
  };
  const updateAllAccounts = (updatedAccounts) => {
    SetViewAccountDetails(updatedAccounts);
  };

  const mapApprovalListItemForSync = (item, data) => {
    if (data?.payload === undefined) {
      return {
        ...item,
        approval_status:
          item.approval_status === "pending" ? "error" : "pending",
        error: "true",
        message: "An error occured while taking action on this account",
      };
    }

    const errors = data?.payload?.errors;
    let errorMessage = "";

    if (errors?.field_force_accounts?.[GlobalConfiguration.lengthCheckZero]) {
      errorMessage =
        errors.field_force_accounts[GlobalConfiguration.lengthCheckZero];
    } else if (
      errors?.bank_account_number?.[GlobalConfiguration.lengthCheckZero]
    ) {
      errorMessage =
        errors.bank_account_number[GlobalConfiguration.lengthCheckZero];
    } else if (!data?.payload?.status) {
      errorMessage = errors?.category?.[GlobalConfiguration.lengthCheckZero];
    } else {
      errorMessage = "An unknown error occurred.";
    }

    if (
      data?.payload?.status === false &&
      errorMessage === "Field force account already approved"
    ) {
      return {
        ...item,
        approval_status:
          item.approval_status === "pending" ? "Approved" : "pending",
        error: "false",
        message: "",
      };
    }

    let lifecycleStatus = "";

    if (data.payload.status === true) {
      lifecycleStatus = "Approved";
    }
    if (data.payload.status === false) {
      lifecycleStatus = "error";
    }

    let message = "";
    if (data.payload.status === false) {
      if (errors?.field_force_accounts?.[GlobalConfiguration.lengthCheckZero]) {
        message =
          errors.field_force_accounts[GlobalConfiguration.lengthCheckZero];
      } else if (data?.payload?.errors === "false") {
        message = errors?.category?.[GlobalConfiguration.lengthCheckZero];
      } else if (
        errors?.bank_account_number?.[GlobalConfiguration.lengthCheckZero]
      ) {
        message =
          errors.bank_account_number[GlobalConfiguration.lengthCheckZero];
      }
    }

    return {
      ...item,
      approval_status:
        item.approval_status === "pending" ? lifecycleStatus : "pending",
      error:
        item.error === "false" && data?.payload.status === false
          ? "true"
          : "false",
      message:
        item.message === "" && data.payload.status === false ? message : "",
    };
  };

  const mapRejectListItemForSync = (item, result, accountIdData) => {
    if (result?.payload?.status === false || result?.payload === undefined) {
      const errors = result?.payload?.errors;
      let error_msg = "";

      if (result?.payload === undefined) {
        error_msg = "An unknown error occurred.";
      } else if (
        errors?.field_force_accounts?.[GlobalConfiguration.lengthCheckZero]
      ) {
        error_msg =
          errors.field_force_accounts[GlobalConfiguration.lengthCheckZero];
      } else if (
        errors?.bank_account_number?.[GlobalConfiguration.lengthCheckZero]
      ) {
        error_msg =
          errors.bank_account_number[GlobalConfiguration.lengthCheckZero];
      } else if (!result?.payload?.status) {
        error_msg = errors?.category?.[GlobalConfiguration.lengthCheckZero];
      } else {
        error_msg = "An unknown error occurred.";
      }

      if (error_msg === "Field force account already rejected") {
        return {
          ...item,
          approval_status: "rejected",
          error: "false",
          message: "",
        };
      }

      return {
        ...item,
        approval_status:
          item.approval_status === "pending" ? "error" : "pending",
        rejected_on: "",
        rejected_by_name: "",
        rejection_reason: accountIdData,
        error: "true",
        message: error_msg,
        pending_transactions: "N",
        pending_scheduled_transactions: "N",
      };
    }

    return {
      ...item,
      approval_status: "rejected",
      rejected_on:
        result?.payload?.field_force_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ]?.rejected_on ?? "",
      rejected_by_name:
        result?.payload?.field_force_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ]?.rejected_by_name ?? "",
      rejection_reason: accountIdData,
      error: "false",
      message: "",
    };
  };

  const mapTxnDetailForAccountApprovalSync = (txn, data) => {
    if (data?.payload?.status === true) {
      return {
        ...txn,
        field_force_account_approval_status: "approved",
      };
    }

    const errors = data?.payload?.errors;
    let errorMessage = "";

    if (data?.payload === undefined) {
      errorMessage = "An unknown error occurred.";
    } else if (
      errors?.field_force_accounts?.[GlobalConfiguration.lengthCheckZero]
    ) {
      errorMessage =
        errors.field_force_accounts[GlobalConfiguration.lengthCheckZero];
    } else if (
      errors?.bank_account_number?.[GlobalConfiguration.lengthCheckZero]
    ) {
      errorMessage =
        errors.bank_account_number[GlobalConfiguration.lengthCheckZero];
    } else if (!data?.payload?.status) {
      errorMessage = errors?.category?.[GlobalConfiguration.lengthCheckZero];
    }

    if (errorMessage === "Field force account already approved") {
      return {
        ...txn,
        field_force_account_approval_status: "approved",
      };
    }

    return txn;
  };

  const mapTxnDetailForAccountRejectSync = (txn, result, accountIdData) => {
    if (result?.payload?.status === true) {
      return {
        ...txn,
        field_force_account_approval_status: "rejected",
      };
    }

    if (result?.payload?.status === false || result?.payload === undefined) {
      const errors = result?.payload?.errors;
      let error_msg = "";

      if (result?.payload === undefined) {
        error_msg = "An unknown error occurred.";
      } else if (
        errors?.field_force_accounts?.[GlobalConfiguration.lengthCheckZero]
      ) {
        error_msg =
          errors.field_force_accounts[GlobalConfiguration.lengthCheckZero];
      } else if (
        errors?.bank_account_number?.[GlobalConfiguration.lengthCheckZero]
      ) {
        error_msg =
          errors.bank_account_number[GlobalConfiguration.lengthCheckZero];
      } else if (!result?.payload?.status) {
        error_msg = errors?.category?.[GlobalConfiguration.lengthCheckZero];
      } else {
        error_msg = "An unknown error occurred.";
      }

      if (error_msg === "Field force account already rejected") {
        return {
          ...txn,
          field_force_account_approval_status: "rejected",
        };
      }
    }

    return txn;
  };

  const syncAccountToApprovalList = (
    accountId,
    accountUpdatesOrMapper,
    txnSync,
  ) => {
    if (!accountId) return;

    if (payload?.setAllAccounts) {
      payload.setAllAccounts((prev) => {
        if (!Array.isArray(prev)) return [];

        return prev.map((acc) => {
          // 🟢 FIX: Check all possible ID fields (field_force_account_id, id, or txn_id)
          const isMatchingAccount =
            String(acc.field_force_account_id) === String(accountId) ||
            String(acc.id) === String(accountId) ||
            String(acc.txn_id) === String(accountId);

          if (!isMatchingAccount) return acc;

          const mappedItem =
            typeof accountUpdatesOrMapper === "function"
              ? accountUpdatesOrMapper(acc)
              : { ...acc, ...accountUpdatesOrMapper };

          return {
            ...mappedItem,
            field_force_account_approval_status:
              txnSync?.type === "reject" ? "rejected" : "Approved",
            approval_status:
              txnSync?.type === "reject" ? "rejected" : "Approved",
          };
        });
      });
    }

    if (payload?.setviewTxnDetails && txnSync) {
      const { type, data, accountIdData } = txnSync;

      payload.setviewTxnDetails((prev) => {
        if (!Array.isArray(prev)) return [];

        return prev.map((txn) => {
          if (String(txn.field_force_account_id) !== String(accountId)) {
            return txn;
          }

          return type === "reject"
            ? mapTxnDetailForAccountRejectSync(txn, data, accountIdData)
            : mapTxnDetailForAccountApprovalSync(txn, data);
        });
      });
    }

    if (payload?.setParentTxnList && txnSync) {
      const { type, data, accountIdData } = txnSync;

      payload.setParentTxnList((prev) => {
        if (!Array.isArray(prev)) return [];

        return prev.map((txn) => {
          if (String(txn.field_force_account_id) !== String(accountId)) {
            return txn;
          }

          return type === "reject"
            ? mapTxnDetailForAccountRejectSync(txn, data, accountIdData)
            : mapTxnDetailForAccountApprovalSync(txn, data);
        });
      });
    }

    if (payload?.setScheduleUpdatedData) {
      payload.setScheduleUpdatedData((prev) => {
        if (!prev?.request || !Array.isArray(prev.request)) {
          return prev;
        }

        return {
          ...prev,
          request: prev.request.map((req) => {
            if (
              String(req.field_force_account_id) !== String(accountId) &&
              String(req.id) !== String(accountId)
            ) {
              return req;
            }

            const mappedItem =
              typeof accountUpdatesOrMapper === "function"
                ? accountUpdatesOrMapper(req)
                : { ...req, ...accountUpdatesOrMapper };

            return {
              ...mappedItem,
              field_force_account_approval_status:
                txnSync?.type === "reject" ? "rejected" : "approved",
            };
          }),
        };
      });
    }
  };

  const archiveAccount = async (targetId) => {
    UniversalRefreshToast("archive");
    const archived_response = await dispatch(
      archiveFieldForceAccount({ id: targetId || id || fieldForceAccountId }),
    );

    if (archiveFieldForceAccount.fulfilled.match(archived_response)) {
      await loadFieldForceDetails(targetId || id || fieldForceAccountId);
      toast.dismiss();
      CommonToast({
        text: "Account archived successfully",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        buttonNeeded: false,
      });
    }
    handleCloseModal();
    setArchiveType("");
    setDeclineReason("");
  };

  const handleArchiveButton = async (targetId) => {
    setArchiveLoader(true);
    const activeId = targetId || id || fieldForceAccountId;

    // Re-fetch account details so pending txn/request flags are not stale
    // after a previous "Reject all" in this session.
    const detailsResponse = await dispatch(
      getSpecificFieldForceAccount({ id: activeId }),
    );
    const accountInfo =
      detailsResponse?.payload?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];

    const hasTxns = accountInfo?.pending_field_force_transactions === "Y";
    const hasReqs = accountInfo?.pending_field_force_requests === "Y";

    if (hasTxns) {
      setAchivedOpenPop(false);
      setArchiveLoader(false);
      setRejectTxnPopup(true);
      setAssociateType("archiveAccount");
    } else if (hasReqs) {
      setAchivedOpenPop(false);
      setArchiveLoader(false);
      setRequestRejectAll(true);
      setAssociateType("archiveAccount");
    } else {
      UniversalRefreshToast("archive");
      const archived_response = await dispatch(
        archiveFieldForceAccount({ id: activeId }),
      );
      if (archiveFieldForceAccount.fulfilled.match(archived_response)) {
        await loadFieldForceDetails(activeId);
        toast.dismiss();
        CommonToast({
          text: "Account archived successfully",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
      }
      handleCloseModal();
      setAchivedOpenPop(false);
      setArchiveLoader(false);
    }
  };
  const handleArchiveRejectTransaction = async () => {
    setShowLoader(true);
    setshowPopupReject(false);
    const AccountIdData = declineReason || "Account Archived";
    const targetedId = id || fieldForceAccountId;
    let linkedTxnIds = [];

    if (fieldForceTxnViewAllData?.transactions?.length > 0) {
      linkedTxnIds = fieldForceTxnViewAllData.transactions.map(
        (tx) => tx?.txn_id,
      );
    }

    UniversalRefreshToast("Rejecting transactions.");

    let txnResponse = null;
    if (linkedTxnIds.length > 0) {
      txnResponse = await dispatch(
        FieldForceMultiTxnDeniedApproval({ id: linkedTxnIds, AccountIdData }),
      );
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (txnResponse?.payload?.status === true || linkedTxnIds.length === 0) {
      setRejectTxnPopup(false);
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: "Associated transactions rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
      }, IntervalConfiguration?.intervalSmall);

      const detailsResponse = await dispatch(
        getSpecificFieldForceAccount({ id: targetedId }),
      );
      const refreshedAccount =
        detailsResponse?.payload?.field_force_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ];

      if (refreshedAccount?.pending_field_force_requests === "Y") {
        if (archiveType === "archive") {
          setArchiveType("Requestarchive");
        }
        setRequestRejectAll(true);
      } else if (refreshedAccount?.pending_field_force_transactions === "Y") {
        // Still pending on server (e.g. only current page was rejected).
        setRejectTxnPopup(true);
      } else {
        archiveAccount(targetedId);
      }
    }
    setShowLoader(false);
  };
  const handleUnArchiveButton = async () => {
    if (archiveActionInFlightRef.current || isArchiveActionSubmitting) {
      return;
    }

    archiveActionInFlightRef.current = true;
    setIsArchiveActionSubmitting(true);

    try {
      if (!hasArchiveServiceAccess) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "FFAAccountArchive" },
        });
        return;
      }
      const acc =
        viewAccountDetailData?.field_force_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ];
      if (!acc) return;

      const pendingTxn = acc.pending_field_force_transactions === "Y";

      if (pendingTxn) {
        setUnachivedOpenPop(false);
        CommonToast({
          text: "Reject pending transactions before unarchiving this account. Use the alerts strip or pending-transaction flow.",
          icon: ICONS.INFO_FILLED,
          variant: "var(--processing)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        return;
      }

      UniversalRefreshToast("unarchive");
      const unarchived_response = await dispatch(
        unarchiveFieldForceAccount({ id }),
      );
      if (unarchiveFieldForceAccount.fulfilled.match(unarchived_response)) {
        await loadFieldForceDetails(id);
        toast.dismiss();
        CommonToast({
          text: "Account unarchived successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
      handleCloseModal();
      setUnachivedOpenPop(false);
    } catch (error) {
      console.error("Failed to unarchive the account", error);
    } finally {
      archiveActionInFlightRef.current = false;
      setIsArchiveActionSubmitting(false);
    }
  };

  // useEffect
  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("fFAccAvailableLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(filterUppercaseLabels(parsedLabels));
  }, [fieldForceAccountId, id, dispatch]);

  useEffect(() => {
    if (viewAccountDetailData) {
      SetViewAccountDetails(viewAccountDetailData?.field_force_accounts);
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.field_force_accounts &&
      viewAccountDetailData.field_force_accounts.length >
        GlobalConfiguration?.lengthCheckZero
    ) {
      const {
        bank_name,
        bank_acc_no,

        category_ids,
        ifsc_code,
        id,
        pan_no,
        name,
      } =
        viewAccountDetailData.field_force_accounts[
          GlobalConfiguration.lengthCheckZero
        ];

      const category = category_ids
        ?.map((category) => category.category_name)
        .join();

      setCurrentAccountDetails({
        bank_name,
        bank_acc_no,
        category,
        ifsc_code,
        id,
        pan: pan_no,
        bank_account_holder_full_name: name,
        name: name,
      });
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration?.mobileScreen);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    let accountData = [];
    if (viewAccountDetailData) {
      accountData =
        viewAccountDetailData?.field_force_accounts[
          GlobalConfiguration.lengthCheckZero
        ].logs;
    }
    if (
      accountData &&
      viewAccountDetailData?.field_force_accounts[
        GlobalConfiguration.lengthCheckZero
      ].archived === "Y"
    ) {
      setNameArchive(
        [...accountData]
          .filter((fil) => {
            return fil.action === "Archived";
          })
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))[
          GlobalConfiguration.lengthCheckZero
        ]?.user_full_name,
      );
    }
  }, [ViewAccountDetails]);

  useEffect(() => {
    if (beneLookData || bankData) {
      if (
        beneLookData?.total_count > GlobalConfiguration?.lengthCheckOne ||
        bankData?.total_count > GlobalConfiguration?.lengthCheckOne
      ) {
      }
    }
  }, [beneLookData, bankData]);

  useEffect(() => {
    sessionStorage.removeItem("PAN GST Edit NewValue");
  }, []);

  const primaryFieldForceAccount =
    viewAccountDetailData?.field_force_accounts?.[
      GlobalConfiguration.lengthCheckZero
    ];

  const hasAssociatedAccountsFound =
    primaryFieldForceAccount?.associate_bank === "Y" ||
    primaryFieldForceAccount?.associate_pan === "Y";

  const hasPendingTransactionsFound =
    primaryFieldForceAccount?.pending_transactions === "Y" ||
    primaryFieldForceAccount?.pending_field_force_transactions === "Y";

  const hasAllCategoriesAssigned =
    primaryFieldForceAccount?.all_category_assign === "Y";

  const buildAlerts = () => [
    ...(hasAllCategoriesAssigned !== undefined
      ? hasAllCategoriesAssigned
        ? [
            {
              isLoading: false,
              // isDisabled: payload?.type === "field_force_account_detail_modal",
              text: "All categories are assigned to this account",
              icon: ICONS?.ALERT,
              onClick: () => {
                // if (payload?.type === "field_force_account_detail_modal") {
                //   actionRestricted();
                //   return;
                // }
                toggleCategories();
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking category assign",
          },
        ]),
    ...(hasAssociatedAccountsFound
      ? [
          {
            isLoading: false,
            isDisabled: payload?.type === "field_force_account_detail_modal",
            text: "Associated accounts are found",
            icon: ICONS?.ALERT,
            onClick: () => {
              if (payload?.type === "field_force_account_detail_modal") {
                actionRestricted();

                return;
              }
              handleAssociatedAccountsClick();
            },
          },
        ]
      : []),
    ...(hasPendingTransactionsFound &&
    primaryFieldForceAccount?.approval_status === "pending"
      ? [
          {
            isLoading: false,
            isDisabled: payload?.type === "field_force_account_detail_modal",
            text: "Pending transactions found",
            icon: ICONS?.ALERT,
            onClick: () => {
              if (payload?.type === "field_force_account_detail_modal") {
                actionRestricted();
                return;
              }
              setRejectTxnPopup(true);
              setAssociateType("FieldForceTxn");
            },
          },
        ]
      : []),
    ...(primaryFieldForceAccount?.pending_field_force_requests === "Y" &&
    primaryFieldForceAccount?.approval_status === "pending"
      ? [
          {
            isLoading: false,
            isDisabled: payload?.type === "field_force_account_detail_modal",
            text: "Pending requests found",
            icon: ICONS?.ALERT,
            onClick: () => {
              if (payload?.type === "field_force_account_detail_modal") {
                actionRestricted();
                return;
              }
              setRequestRejectAll(true);
              setAssociateType("RejectAllRequestTxn");
            },
          },
        ]
      : []),
  ];

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  useEffect(() => {
    if (payload?.showCategory) {
      setIndex(GlobalConfiguration?.lengthCheckOne);
      setShowCategories(true);
      setShowContactDetails(false);
      setShowAssignedLabels(false);
      setAdditionalRecipicent(false);
    }
  }, [id, fieldForceAccountId, payload?.showCategory]);

  return (
    <>
      <>{RestrictedActionPopup}</>
      {showAdditionalSection && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <AdditionalRecipient
            finalRecipients={finalRecipients}
            setShowAdditionalSection={setShowAdditionalSection}
            accountID={id}
            showAdditionalRecipient={showAdditionalRecipient}
            setShowAdditionalRecipient={setShowAdditionalRecipient}
            handleConfirm={handleConfirm}
            recipients={recipients}
            setRecipients={setRecipients}
            buttonDisabled={recipientButtonDisabled}
            setButtonDisabled={setRecipientButtonDisabled}
            additionalChip={additionalChip}
            setAdditionalChip={setAdditionalChip}
            isLoaderNeed={buttonLoader}
            loaderNeed={buttonLoader}
          />
        </div>
      )}
      {showGstPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state:
                ViewAccountDetails?.[GlobalConfiguration.lengthCheckZero]
                  ?.gstin_detail,
            })
          }
          closeiconhandleFunction={() => setGstShowPopup(false)}
        >
          <GSTVerification
            gst_number={
              ViewAccountDetails?.[GlobalConfiguration.lengthCheckZero]
                ?.gstin_detail
            }
            popup={true}
          />
        </LargePopupRedirect>
      )}

      {showIfscPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="IFSC Details"
            headersubtext="The following shows IFSC details for the associated account."
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(
                `/settings/IFSC_verification/IFSC_Details/${ViewAccountDetails?.[GlobalConfiguration.lengthCheckZero]?.ifsc_code}`,
              )
            }
            closeiconhandleFunction={() => setIfscShowPopup(false)}
          >
            <IFSCDetails
              ifsc_code={
                ViewAccountDetails?.[GlobalConfiguration.lengthCheckZero]
                  ?.ifsc_code
              }
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showPanPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="PAN Details"
            headersubtext="The following shows PAN details of the associated account."
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/PAN_verification`, {
                state:
                  ViewAccountDetails?.[GlobalConfiguration.lengthCheckZero]
                    ?.pan_no,
              })
            }
            closeiconhandleFunction={() => setPanShowPopup(false)}
          >
            <PanVerification
              pan_no={
                ViewAccountDetails?.[GlobalConfiguration.lengthCheckZero]
                  ?.pan_no
              }
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}

      {alertPopUp && (
        <div className="fixed top-top-base left-left-base w-full h-full flex items-center bg-Primary-black justify-center z-z-index-max bg-dark-opacity">
          <FullScreen
            id={fieldForceAccountId}
            setAlertPopUp={setAlertPopUp}
          />
        </div>
      )}
      {userpopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-max-zindex bg-custom-backdrop bg-opacity-dark-opacity">
          <UserDetailsPopup
            User_account_id={userid}
            type="User_details"
            closeBeneAccountDetailModal={() => {
              setUserpopup(false);
            }}
          />
        </div>
      )}

      <div
        id="webviewdetailPage"
        className={`${
          payload?.type === "field_force_account_detail_modal"
            ? "h-height-full"
            : ""
        }`}
      >
        <div
          className={`main-div flex flex-col ${payload.type === "field_force_account_detail_modal" ? " h-full" : "h-screen"}  ${
            achivedOpenPop || isEditModalOpen
              ? "overflow-hidden"
              : payload.type === "field_force_account_detail_modal"
                ? " overflow-x-hidden"
                : "overflow-y-auto overflow-x-hidden"
          }`}
        >
          {showRejectTnxPopup && (
            <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-custom-backdrop bg-opacity-dark-opacity">
              <div ref={popupRef}>
                <LargePopupRedirect
                  headerTitle="Associated transactions found"
                  headersubtext={
                    archiveType === "archive"
                      ? "The following transactions are linked and need to be rejected before archiving this account."
                      : "The following transactions are linked and need to be rejected before rejecting this account."
                  }
                  closeiconenabledBgColor="var(--primary-nav)"
                  closeiconisLoading={false}
                  closeiconhandleFunction={() => {
                    setShowLoader(false);
                    handleClosePopup();
                  }}
                  closeicon={ICONS?.CLOSE}
                  closeiconhoverOption="white"
                  closeiconbtnType={"button"}
                  closeiconisDisabled={false}
                  closeicondisabledBgColor={""}
                  closeiconbuttonRef={null}
                  closeicontitle={"Close"}
                  btnType={"button"}
                  bottomHeaderTextNeed={true}
                  bottomHeaderText={
                    archiveType === "archive"
                      ? "To archive the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
                      : "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
                  }
                  isbottomSectionneed={true}
                  btnText={"Reject all"}
                  confirmbtnrequired={true}
                  handleFunction={() => {
                    const hasAccess = services?.find(
                      (service) =>
                        service === "AFieldForceTxn" || service === "Admin",
                    );
                    if (!hasAccess) return;

                    if (associatePending === "AlertPendingTxn") {
                      handleAccRejectAlert();
                    } else if (archiveType === "archive") {
                      handleArchiveReject();
                    } else {
                      handleRejectAllTransaction();
                    }
                  }}
                  enabledBgColor={"var(--negative-act)"}
                  outLineColor={""}
                  enabledTextColor={"var(--text-primary)"}
                  fullWidthRequired={false}
                  inActiveVariantNeeded
                  isDisabled={
                    services?.find(
                      (service) => service === "AFieldForceTxn",
                    ) === undefined
                  }
                  disabledTextColor={"var(--text-primary)"}
                  disabledBgColor={"var(--text-disabled)"}
                >
                  {showRejectTnxPopup && (
                    <>
                      {" "}
                      <FieldForceTransactionViewAll
                        TxnHistoryid={fieldForceAccountId || id}
                        bene_account_id={fieldForceAccountId || id}
                        typepop={"reimburse_txnViewAll_popup_reject"}
                        flowType={
                          payload?.type === "scheduleAcc"
                            ? "scheduleAcc"
                            : associatePending === "AlertPendingTxn"
                              ? "AlertPendingTxn"
                              : "decline account details"
                        }
                        closeRejectAllTxn={handleClosePopup}
                        bene_account_name={
                          viewAccountDetailData?.field_force_accounts?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.name
                        }
                        handleRejectAllTransaction={
                          associatePending === "AlertPendingTxn"
                            ? handleAccRejectAlert
                            : handleRejectAllTransaction
                        }
                        type={
                          embeddedBeneTxnModalType ||
                          "bene_account_detail_modal"
                        }
                        setShowLoader={setShowLoader}
                        setSidebarState={(e) => {}}
                        setShowScheduleTxnPopup={setShowScheduleTxnPopup}
                        showLoader={showLoader}
                        setFocus={(e) => {}}
                        isPopupMode={true}
                      />
                    </>
                  )}
                </LargePopupRedirect>
              </div>
            </div>
          )}

          {loading || !viewAccountDetailData?.field_force_accounts?.length ? (
            <div className="loader-container m-auto justify-center items-center flex">
              <Loader />
            </div>
          ) : (
            <>
              <div
                className={`bg-primary-nav mt-margin-base fixed top-top-base left-left-base w-width-full z-z-index-overlay Qmd:hidden ${payload?.type === "field_force_account_detail_modal" && "hidden"}`}
              >
                <TopNavComponent
                  topNavHeader={"Field force"}
                  isFormattingNotRequired
                  topNavSubText="Account details"
                  handleBack={(e) => {
                    navigate(GlobalConfiguration.navigate_back);
                  }}
                />
              </div>
              <div
                className={` h-auto Qmd:bg-primary-nav bg-primary-card ${
                  payload?.type === "field_force_account_detail_modal"
                    ? null
                    : "main-alignment"
                }`}
              >
                {RequestRejectAll && (
                  <>
                    <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
                      <LargePopupRedirect
                        headerTitle="Pending requests found"
                        headersubtext={
                          associateType === "rejectAccount"
                            ? "The following requests are linked and need to be rejected before rejecting this account."
                            : "The following requests are linked and need to be rejected before archiving this account."
                        }
                        headerFontWeight="semibold"
                        headerFontColor="text-primary"
                        headertextSize="font-md"
                        fullviewisDisabled={false}
                        fullviewenabledTextColor="var(--text-primary)"
                        fullviewenabledBgColor="var(--primary-nav)"
                        fullviewhoverOption="white"
                        fullviewicon={ICONS?.REDIRECT}
                        fullviewdisabledBgColor="var(--text-disabled)"
                        closeiconbtnType="button"
                        closeiconhandleFunction={() => {
                          setRequestRejectAll(false);
                          setDeclineReason("");
                          handleClosePopup();
                        }}
                        closeiconisDisabled={false}
                        closeiconenabledBgColor="var(--primary-nav)"
                        closeicondisabledBgColor="var(--text-disabled)"
                        closeiconhoverOption="white"
                        closeicon={ICONS?.CLOSE}
                        bottomHeaderTextNeed={true}
                        bottomHeaderText={
                          associateType === "rejectAccount"
                            ? "To reject the account, please reject the requests listed above by clicking the “Reject all” button. The requests will get rejected with the provided rejected reason."
                            : "To archive this account, please reject the requests listed above by clicking the “Reject all” button. The requests will get rejected with the provided rejected reason."
                        }
                        isbottomSectionneed={true}
                        btnText={"Reject all"}
                        confirmbtnrequired={true}
                        handleFunction={() => {
                          const hasAccess = services?.find(
                            (service) =>
                              service === "AFieldForceRequest" ||
                              service === "Admin",
                          );
                          if (!hasAccess) return;

                          if (associateType === "RejectAllRequestTxn") {
                            setshowPopupReject(true);
                          } else if (archiveType === "archive") {
                            if (
                              declineReason &&
                              declineReason.trim().length > 0
                            ) {
                              handleRejectRequestTxn();
                            } else {
                              setshowPopupReject(true);
                            }
                          } else {
                            handleRejectRequestTxn();
                          }
                        }}
                        enabledBgColor={"var(--negative-act)"}
                        hoverOption={"dark"}
                        isLoaderNeeded={true}
                        isLoading={showLoader ? true : false}
                        outLineColor={""}
                        enabledTextColor={"var(--text-primary)"}
                        inActiveVariantNeeded
                        isDisabled={
                          services?.find(
                            (service) => service === "AFieldForceRequest",
                          ) === undefined
                        }
                        disabledTextColor={"var(--text-primary)"}
                        disabledBgColor={"var(--text-disabled)"}
                      >
                        <FieldForceTxnRequestViewAll
                          TxnHistoryid={
                            viewAccountDetailData?.field_force_accounts?.[0]?.id
                          }
                          TxnHistoryAccountName={
                            viewAccountDetailData?.field_force_accounts?.[0]
                              ?.name
                          }
                          typepop="requestViewallPopup"
                          flowType="RequestRejectAll"
                          closeRejectAllTxn={handleClosePopup}
                          setShowLoader={setShowLoader}
                          showLoader={showLoader}
                          type="requestViewallPopup"
                          isPopupMode={true}
                        />
                      </LargePopupRedirect>
                    </div>
                  </>
                )}

                {showPopupReject && (
                  <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
                    <SmallPopupWithInput
                      inputAdornment={false}
                      headerTitle={"Reject account"}
                      headerFontWeight="semibold"
                      headerFontColor="text-primary"
                      textSize="font-md"
                      subtext={TEXT?.PROVIDE_REJECT_REQUEST_REASON_PROMPT}
                      noteText="Minimum 10 characters required."
                      isTextInputField={true}
                      inputPlaceholder="Reason"
                      subtextwithbullet="Y"
                      bulletPoints={[
                        "New requests and transactions cannot be created for this account.",
                        "Before rejecting this account, reject all associated transactions and requests.",
                        "Users can edit the rejected account to update its details.",
                      ]}
                      inputVariant={computeVariant(declineReason, isFocused)}
                      inputOnFocus={(e) => setIsFocused(true)}
                      inputOnBlur={(e) => setIsFocused(false)}
                      inputIsDisabled={showLoader ? true : false}
                      btnOneIsDisabled={showLoader ? true : false}
                      inputBgColor="var(--primary-bg)"
                      inputFgColor="var(--text-secondary)"
                      inputOnInput={(e) => {
                        if (!showLoader) {
                          handleInputChange(e);
                        }
                      }}
                      inputValue={declineReason}
                      inputFontKind="big"
                      inputIsFullWidth={true}
                      btnOneText="Cancel"
                      btnOneHandleFunction={() => {
                        if (!showLoader) {
                          handleClosePopup();
                        }
                      }}
                      btnOneEnabledBgColor="var(--primary-bg)"
                      btnOneOutLineColor="var(--text-primary)"
                      btnOneEnabledTextColor="var(--text-primary)"
                      btnOneHoverOption="white"
                      btnTwoText="Reject"
                      btnTwoHandleFunction={() => {
                        if (associatePending === "AlertPendingTxn") {
                          handleRejectAlert();
                        } else if (associateType === "FieldForceTxn") {
                          handleRejectAllTransaction();
                        } else if (archiveType === "archive") {
                          handleArchiveChecker();
                        } else {
                          handleRejectChecker(deniedId, declineReason);
                        }
                      }}
                      btnTwoEnabledBgColor="var(--negative-act)"
                      btnTwoEnabledTextColor="var(--text-primary)"
                      btnTwoIsDisabled={
                        !declineReason ||
                        declineReason.length < GlobalConfiguration?.panLength
                      }
                      btnTwoDisabledBgColor="var(--text-disabled)"
                      btnTwoIsLoaderNeeded={showLoader ? true : false}
                      btnTwoIsLoading={showLoader ? true : false}
                      btnTwoHoverOption="black"
                      btnTwoInActiveVariantNeeded={true}
                    />
                  </div>
                )}

                {openfieldForceAssociate && (
                  <FieldForceAccountAssociatePopup
                    handleClick={handleClick}
                    handleCloseModal={handleCloseModal}
                    showModalPopup={openfieldForceAssociate}
                    createFieldForceAccountLoading={
                      getSpecificFieldForceAccountLoading
                    }
                    accountNumber={
                      viewAccountDetailData?.field_force_accounts[0].bank_acc_no
                    }
                    ifsc={
                      viewAccountDetailData?.field_force_accounts[0].ifsc_code
                    }
                    panNumber={
                      viewAccountDetailData?.field_force_accounts[0].pan_no
                    }
                    setActiveType={setActiveType}
                    setFieldForcePan={setFieldForcePan}
                    setFieldForceAccount={setFieldForceAccount}
                    setFieldForceIFSC={setFieldForceIFSC}
                    fieldForceIFSC={fieldForceIFSC}
                    fieldForceAccount={fieldForceAccount}
                    fieldForcePan={fieldForcePan}
                    activeType={activeType}
                    isBottomRequired={false}
                    id={viewAccountDetailData?.field_force_accounts?.[0]?.id}
                  />
                )}
                {openBeneAssociate && (
                  <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
                    <LargePopupRedirect
                      headerTitle="Associated accounts"
                      headersubtext="The accounts listed below are linked to the selected field force account."
                      closeiconenabledBgColor="var(--primary-nav)"
                      closeiconisLoading={false}
                      closeiconhandleFunction={() => {
                        dispatch(resetToggleFfa());
                        setFieldForcePan("");
                        setFieldForceAccount("");
                        setFieldForceIFSC("");
                        setActiveType("pan");
                        setOpenBeneAssociate(false);
                      }}
                      closeicon={ICONS?.CLOSE}
                      closeiconhoverOption="white"
                      closeiconbtnType={"button"}
                      closeiconisDisabled={false}
                      closeicondisabledBgColor={""}
                      closeiconbuttonRef={null}
                      closeicontitle={"Close"}
                      btnType={"button"}
                      confirmbtnrequired={true}
                      enabledBgColor={"var(--negative-act)"}
                      hoverOption={"dark"}
                      outLineColor={""}
                      enabledTextColor={"var(--text-primary)"}
                      fullWidthRequired={false}
                      isDisabled={false}
                      disabledTextColor={""}
                      disabledBgColor={""}
                      ispanbankRequired={true}
                      togglepan={() => {
                        setActiveType("pan");
                        setFieldForcePan(currentAccountDetails?.pan ?? "");
                        setFieldForceAccount("");
                        setFieldForceIFSC("");
                      }}
                      toggleBank={() => {
                        setActiveType("bank");
                        setFieldForcePan("");
                        setFieldForceAccount(
                          currentAccountDetails?.bank_acc_no ?? "",
                        );
                        setFieldForceIFSC(
                          currentAccountDetails?.ifsc_code ?? "",
                        );
                      }}
                    >
                      <FieldForceAccountViewAll
                        id={
                          viewAccountDetailData?.field_force_accounts?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.id
                        }
                        type={"fieldForceAccount"}
                        popupType={"associated"}
                        fieldForcePan={fieldForcePan}
                        fieldForceAccount={fieldForceAccount}
                        fieldForceIFSC={fieldForceIFSC}
                        setOpenBeneAssociate={setOpenBeneAssociate}
                        openBeneAssociate={openBeneAssociate}
                        restrictAssociatedAccountNavigation={
                          payload?.type === "field_force_account_detail_modal"
                        }
                      />
                    </LargePopupRedirect>
                  </div>
                )}

                {unachivedOpenPop && (
                  <div
                    onClick={() => {
                      if (!isArchiveActionSubmitting) {
                        handleCloseModal();
                      }
                    }}
                    className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
                  >
                    <SmallPopupWithBulletPoints
                      headerTitle={"Confirm unarchiving this account?"}
                      bulletPoints={[
                        "This account will become inactive.",
                        "The status will be changed to pending and will require approval.",
                      ]}
                      btnOneText="Cancel"
                      btnOneBtnType="button"
                      btnOneEnabledBgColor="transparent"
                      btnOneHandleFunction={handleCloseModal}
                      btnOneOutLineColor="var(--text-primary)"
                      btnOneEnabledTextColor="var(--text-primary)"
                      btnOneIsDisabled={isArchiveActionSubmitting}
                      btnOneHoverOption="white"
                      btnTwoText="Unarchive"
                      btnTwoBtnType="button"
                      btnTwoHandleFunction={handleUnArchiveButton}
                      btnTwoEnabledBgColor="var(--positive-act)"
                      btnTwoEnabledTextColor="var(--text-primary)"
                      btnTwoIsDisabled={isArchiveActionSubmitting}
                      btnTwoHoverOption="black"
                    />
                  </div>
                )}
                {achivedOpenPop && (
                  <div
                    onClick={() => {
                      if (!isArchiveActionSubmitting) {
                        handleCloseModal();
                      }
                    }}
                    className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
                  >
                    <div>
                      <SmallPopupWithBulletPoints
                        headerTitle={"Confirm archiving this account?"}
                        headerFontWeight="semibold"
                        headerFontColor="text-primary"
                        textSize="font-md"
                        bulletPoints={[
                          "This account will become inactive.",
                          "Account cannot be used unless unarchived.",
                        ]}
                        btnOneText="Cancel"
                        btnOneBtnType="button"
                        btnOneEnabledBgColor="transparent"
                        btnOneHandleFunction={handleCloseModal}
                        btnOneOutLineColor="var(--text-primary)"
                        btnOneEnabledTextColor="var(--text-primary)"
                        btnOneIsDisabled={isArchiveActionSubmitting}
                        btnTwoIsLoaderNeeded={true}
                        btnTwoIsLoading={archiveloader ? true : false}
                        btnOneHoverOption="white"
                        btnTwoText="Archive"
                        btnTwoBtnType="button"
                        btnTwoHandleFunction={() => {
                          setArchiveLoader(true);
                          setArchiveType("archive");
                          handleArchiveButton(
                            viewAccountDetailData?.field_force_accounts?.[0]
                              ?.id,
                          );
                        }}
                        btnTwoEnabledBgColor="var(--negative-act)"
                        btnTwoEnabledTextColor="var(--text-primary)"
                        btnTwoIsDisabled={
                          isArchiveActionSubmitting ||
                          archiveFieldForceAccountloading
                        }
                        btnTwoHoverOption="black"
                      />
                    </div>
                  </div>
                )}

                {openTransHistory && (
                  <LargePopupRedirect
                    headerTitle={"Transaction history"}
                    headersubtext={
                      "All transactions related to the field force account are listed below."
                    }
                    closeiconenabledBgColor="var(--primary-nav)"
                    closeiconisLoading={false}
                    closeiconhandleFunction={() => closeTransactionHistory()}
                    closeicon={ICONS?.CLOSE}
                    closeiconhoverOption="white"
                    closeiconbtnType={"button"}
                    closeiconisDisabled={false}
                    closeicondisabledBgColor={""}
                    closeiconbuttonRef={null}
                    closeicontitle={"Close"}
                    btnType={"button"}
                    enabledBgColor={"var(--negative-act)"}
                    hoverOption={"dark"}
                    outLineColor={""}
                    enabledTextColor={"var(--text-primary)"}
                    fullWidthRequired={false}
                    isDisabled={false}
                    disabledTextColor={""}
                    disabledBgColor={""}
                  >
                    <FieldForceTransactionViewAll
                      bene_account_name={
                        viewAccountDetailData?.field_force_accounts[
                          GlobalConfiguration.lengthCheckZero
                        ]?.name
                      }
                      bene_account_id={
                        viewAccountDetailData?.field_force_accounts[
                          GlobalConfiguration.lengthCheckZero
                        ]?.id
                      }
                      bene_account_confidential={null}
                      onClose={closeTransactionHistory}
                      typepop={"txnHistorypopup"}
                    />
                  </LargePopupRedirect>
                )}

                {openRequestHistory && (
                  <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
                    <FieldForceRequestViewAllPopup
                      closeFfTxnDetailsModal={closeRequestHistory}
                      TxnHistoryid={
                        viewAccountDetailData?.field_force_accounts?.[0]?.id ||
                        fieldForceAccountId ||
                        id
                      }
                      TxnHistoryAccountName={
                        viewAccountDetailData?.field_force_accounts?.[0]?.name
                      }
                      categoryName={category}
                      type="requestViewallPopup"
                    />
                  </div>
                )}

                {showLabelsPopup && (
                  <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
                    <CommonAssignLabelPopup
                      headerTitle="Assign/unassign labels:"
                      headersubtext="Labels will be used to generate statistics for the associated accounts."
                      closehandleFunction={handleClose}
                      closeisDisabled={false}
                      labels={labels}
                      setLabels={setLabels}
                      LabelAccounts={id}
                      isLabelPopupOpen={showLabelsPopup}
                      filteredData={viewAccountDetailData?.field_force_accounts?.map(
                        (account) => ({
                          ...account,
                          labels: filterUppercaseLabels(account?.labels),
                        }),
                      )}
                      onClose={handleClose}
                      loading={labelLoading}
                      setLoading={setLabelLoading}
                      handleAssignLabels={handleAssignLabelsProp}
                      handleUnassignLabels={handleUnassignLabelsProp}
                    />
                  </div>
                )}
                <div
                  className={`w-full max-w-screen-Qlg m-auto Qmd:bg-primary-nav bg-primary-card ${payload?.type === "field_force_account_detail_modal" ? "" : "Qmd:mt-margin-sm"}`}
                  id="container"
                >
                  <div className="flex w-full bg-primary-nav m-auto h-height-sm Qlg:px-padding-base">
                    <div
                      className={`w-full ${
                        payload?.type === "field_force_account_detail_modal"
                          ? ""
                          : "mt-margin-base Qmd:mt-margin-lg"
                      }`}
                    >
                      {viewAccountDetailData?.field_force_accounts?.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="flex border-b border-solid border-primary-bg justify-between mx-margin-md Qmd:mx-margin-base Qmd:mt-margin-xs"
                          >
                            <div className="flex flex-col Qmd:flex-row w-full">
                              <div className="py-padding-md w-full Qmd:w-right-half border-b Qmd:border-b-border-base border-solid border-primary-bg">
                                <div className="flex flex-col Qmd:pl-padding-sm">
                                  <TitleSubtitlePair
                                    title={account.name.trim()}
                                    titleColor="text-primary "
                                    subtitle={
                                      account?.name?.trim() ===
                                      account?.pan_legal_name?.trim()
                                        ? "Account name - Using legal name"
                                        : "Account name"
                                    }
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                  />
                                </div>
                              </div>
                              <div className="hidden Qmd:block border-r border-solid border-primary-bg my-margin-md"></div>
                              {ViewAccountDetails?.map((account) => (
                                <div
                                  key={account.id}
                                  className="w-full Qmd:w-right-half py-padding-md"
                                >
                                  <div className="flex flex-col items-start Qmd:pl-padding-md">
                                    <TitleSubtitlePair
                                      title={
                                        (account?.approval_status ===
                                          "pending" ||
                                          account?.approval_status ===
                                            "error") &&
                                        services?.includes("FFAAccount")
                                          ? "Require approval"
                                          : account?.approval_status === "error"
                                            ? "Pending"
                                            : account?.approval_status
                                                ?.toLowerCase()
                                                ?.split(" ")
                                                ?.map(
                                                  (word) =>
                                                    word
                                                      .charAt(
                                                        GlobalConfiguration?.lengthCheckZero,
                                                      )
                                                      .toUpperCase() +
                                                    word.slice(
                                                      GlobalConfiguration?.lengthCheckOne,
                                                    ),
                                                )
                                                ?.join(" ")
                                      }
                                      titleColor={`${
                                        account.approval_status === "pending" ||
                                        account.approval_status === "error"
                                          ? "pending"
                                          : account.approval_status ===
                                              "approved"
                                            ? "awaiting"
                                            : account.approval_status ===
                                                "rejected"
                                              ? "failed"
                                              : account.approval_status ===
                                                  "blocked"
                                                ? "failed"
                                                : account.approval_status ===
                                                    "archived"
                                                  ? "abandoned"
                                                  : ""
                                      }`}
                                      subtitle="Account status"
                                      alignRight={false}
                                      hoverOption="white"
                                      isBold={false}
                                      variant="md"
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="associated-account-transaction-history-block field-force-detail-actions-col Qmd:flex flex-row bg-primary-nav-act hidden">
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Linked <br /> user
                                  </>
                                }
                                handleFunction={handleLinkedUser}
                                icon={ICONS?.LINKED_WHITE_CIRCLE}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                isDisabled={
                                  payload.type ===
                                  "field_force_account_detail_modal"
                                    ? true
                                    : services?.find(
                                          (service) =>
                                            service === "VSpecificEmp" ||
                                            service === "Admin",
                                        ) !== undefined &&
                                        viewAccountDetailData
                                          ?.field_force_accounts?.[
                                          GlobalConfiguration.lengthCheckZero
                                        ]?.field_force_user_full_name
                                      ? false
                                      : viewAccountDetailData
                                            ?.field_force_accounts?.[
                                            GlobalConfiguration.lengthCheckZero
                                          ]?.field_force_user_full_name
                                        ? false
                                        : true
                                }
                                hoverOption="white"
                              />
                              <div className="py-padding-button-l flex">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Associated <br /> accounts
                                  </>
                                }
                                handleFunction={handleAssociatedAccountsClick}
                                icon={ICONS?.ASSSOCIATED_ACCOUNTS_FOUND}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                isDisabled={
                                  payload.type ===
                                  "field_force_account_detail_modal"
                                }
                                hoverOption="white"
                              />
                              <div className="py-padding-button-l flex">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Transaction <br /> history
                                  </>
                                }
                                handleFunction={handleTransactionHistoryClick}
                                icon={ICONS?.TRANSACTION_HISTORY}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                hoverOption="white"
                                isDisabled={
                                  payload.type ===
                                  "field_force_account_detail_modal"
                                }
                              />
                            </div>
                          </div>
                        ),
                      )}
                      {viewAccountDetailData?.field_force_accounts?.map(
                        (account) => (
                          <div
                            key={account?.id}
                            className="bene-account-holder-details flex border-b border-solid border-primary-bg justify-between mx-margin-md Qmd:mx-margin-base"
                          >
                            <div className="flex flex-col Qmd:flex-row w-full">
                              <div className="py-padding-md Qmd:pl-padding-sm flex gap-gap-sm justify-between items-center Qmd:pr-padding-md w-full Qmd:w-right-half Qmd:border-b-border-base border-b border-solid border-primary-bg">
                                <TitleSubtitlePair
                                  title={(() => {
                                    const accNo =
                                      account?.bank_acc_no ??
                                      account?.bank_account_no;
                                    if (
                                      accNo == null ||
                                      String(accNo).trim() === ""
                                    ) {
                                      return "—";
                                    }
                                    return formatAccountNumber(
                                      String(accNo).toUpperCase(),
                                    );
                                  })()}
                                  titleColor="text-primary"
                                  subtitle="  Account number"
                                  alignRight={false}
                                  hoverOption="white"
                                  isBold={false}
                                  variant="md"
                                />
                                <div className="h-[max-content] flex justify-center items-center bg-text-primary rounded-border-radius-md">
                                  <CommonBankLogo
                                    ifsc={account?.ifsc_code || account?.ifsc}
                                    variant="big"
                                    type="pill"
                                  />
                                </div>
                              </div>
                              <div className="hidden Qmd:block border-r border-solid border-primary-bg my-margin-md"></div>
                              <div className="py-padding-md w-full Qmd:w-right-half">
                                <div className="flex flex-col items-start Qmd:pl-padding-md">
                                  <TitleSubtitlePair
                                    title={
                                      account?.bank_account_holder_full_name ||
                                      account?.name ||
                                      ""
                                    }
                                    titleColor="text-primary"
                                    subtitle=" Bank account holder name"
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="settings field-force-detail-actions-col Qmd:flex flex-row hidden bg-primary-nav-act justify-end ">
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Request <br /> history
                                  </>
                                }
                                handleFunction={handleRequestHistoryClick}
                                icon={ICONS?.TRANSACTION_HISTORY}
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                disabledBgColor="var(--primary-nav-act)"
                                hoverOption="white"
                                isDisabled={
                                  payload.type ===
                                  "field_force_account_detail_modal"
                                }
                              />
                              <div className="py-padding-button-l flex">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>
                              {services?.find(
                                (service) =>
                                  service === "FFUAccount" ||
                                  service === "Admin",
                              ) === undefined ||
                              viewAccountDetailData?.field_force_accounts[
                                GlobalConfiguration.lengthCheckZero
                              ].approval_status === "archived" ||
                              viewAccountDetailData?.field_force_accounts[
                                GlobalConfiguration.lengthCheckZero
                              ].approval_status === "blocked" ? (
                                <TopNavSmallButton
                                  btnText={
                                    <>
                                      Edit <br /> account
                                    </>
                                  }
                                  handleFunction={() => {
                                    if (
                                      viewAccountDetailData
                                        ?.field_force_accounts[
                                        GlobalConfiguration.lengthCheckZero
                                      ].approval_status !== "archived" &&
                                      viewAccountDetailData
                                        ?.field_force_accounts[
                                        GlobalConfiguration.lengthCheckZero
                                      ].approval_status !== "blocked"
                                    ) {
                                      if (
                                        services?.find(
                                          (service) =>
                                            service === "FFUAccount" ||
                                            (service === "Admin" &&
                                              payload?.servicesType !==
                                                "BenAdmin"),
                                        ) !== undefined
                                      ) {
                                        handleEditAccountClick();
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "FFUAccount",
                                          },
                                        });
                                      }
                                    }
                                  }}
                                  icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                                  enabledTextColor="var(--text-primary)"
                                  enabledBgColor="var(--primary-nav-act)"
                                  disabledBgColor="var(--primary-nav-act)"
                                  hoverOption="white"
                                  isDisabled={
                                    payload.type ===
                                      "field_force_account_detail_modal" ||
                                    services?.find(
                                      (service) =>
                                        service === "FFUAccount" ||
                                        service === "Admin",
                                    ) === undefined ||
                                    viewAccountDetailData?.field_force_accounts[
                                      GlobalConfiguration.lengthCheckZero
                                    ].approval_status === "archived" ||
                                    viewAccountDetailData?.field_force_accounts[
                                      GlobalConfiguration.lengthCheckZero
                                    ].approval_status === "blocked"
                                  }
                                />
                              ) : (
                                <>
                                  <TopNavSmallButton
                                    btnText={
                                      <>
                                        Edit <br /> account
                                      </>
                                    }
                                    handleFunction={() => {
                                      if (
                                        payload?.type !==
                                        "field_force_account_detail_modal"
                                      ) {
                                        if (
                                          services?.find(
                                            (service) =>
                                              service === "FFUAccount" ||
                                              service === "Admin",
                                          ) !== undefined
                                        ) {
                                          handleEditAccountClick();
                                        } else {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService: "FFUAccount",
                                            },
                                          });
                                        }
                                      } else if (
                                        payload.type ===
                                        "field_force_account_detail_modal"
                                      ) {
                                        actionRestricted();
                                      }
                                    }}
                                    icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                                    enabledTextColor="var(--text-primary)"
                                    enabledBgColor="var(--primary-nav-act)"
                                    disabledBgColor="var(--primary-nav-act)"
                                    hoverOption="white"
                                    isDisabled={
                                      payload.type ===
                                        "field_force_account_detail_modal" ||
                                      services?.find(
                                        (service) =>
                                          service === "FFUAccount" ||
                                          service === "Admin",
                                      ) === undefined
                                    }
                                  />
                                  {isEditModalOpen && (
                                    <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
                                      <EditCommonPopup
                                        btnOneHandleFunction={
                                          handleEditModalClose
                                        }
                                        headerTitle="Select the option to edit:"
                                        alertText="Make sure you understand the impact before archiving."
                                        alertBackground="emphasis"
                                        chipsArray={chipsArray}
                                        btnOneText="Cancel"
                                        btnOneEnabledBgColor="var(--primary-bg)"
                                        btnOneEnabledTextColor="var(--text-primary)"
                                        btnOneHoverOption="white"
                                        btnOneOutLineColor="var(--text-primary)"
                                        btnTwoText="Edit"
                                        btnTwoHandleFunction={handleApply}
                                        btnTwoIsDisabled={
                                          selectedChipIndex === null ||
                                          selectedChipIndex ===
                                            GlobalConfiguration.lengthCheckZero
                                        }
                                        btnTwoDisabledTextColor="var(--text-primary)"
                                        btnTwoEnabledBgColor="var(--text-primary)"
                                        btnTwoEnabledTextColor="var(--primary-bg)"
                                        btnTwoDisabledBgColor="var(--text-disabled)"
                                        btnTwoInActiveVariantNeeded={true}
                                        btnTwoHoverOption="black"
                                        defaultHeight={selectedChipIndex}
                                      />
                                    </div>
                                  )}
                                </>
                              )}
                              <div className="py-padding-button-l flex">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>
                              {viewAccountDetailData?.field_force_accounts[
                                GlobalConfiguration.lengthCheckZero
                              ].approval_status === "blocked" ||
                              services?.find(
                                (service) =>
                                  service === "FFAAccountArchive" ||
                                  service === "Admin",
                              ) === undefined ? (
                                <TopNavSmallButton
                                  btnText={label}
                                  handleFunction={() => {
                                    if (
                                      viewAccountDetailData
                                        ?.field_force_accounts[
                                        GlobalConfiguration.lengthCheckZero
                                      ].approval_status !== "blocked"
                                    ) {
                                      if (
                                        services?.find(
                                          (service) =>
                                            service === "FFAAccountArchive" ||
                                            service === "Admin",
                                        ) !== undefined
                                      ) {
                                        setArchiveType("archive");
                                        handleUnarchive();
                                        handleArchive();
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService:
                                              "FFAAccountArchive",
                                          },
                                        });
                                      }
                                    }
                                  }}
                                  icon={
                                    viewAccountDetailData?.field_force_accounts[
                                      GlobalConfiguration.lengthCheckZero
                                    ].approval_status === "archived"
                                      ? ICONS?.UNARCHIVE
                                      : ICONS?.ARCHIVE
                                  }
                                  enabledTextColor="var(--text-primary)"
                                  enabledBgColor="var(--primary-nav-act)"
                                  disabledBgColor="var(--primary-nav-act)"
                                  hoverOption="white"
                                  isDisabled={
                                    payload.type ===
                                      "field_force_account_detail_modal" ||
                                    viewAccountDetailData?.field_force_accounts[
                                      GlobalConfiguration.lengthCheckZero
                                    ].approval_status === "blocked"
                                  }
                                />
                              ) : (
                                <TopNavSmallButton
                                  btnText={
                                    viewAccountDetailData?.field_force_accounts[
                                      GlobalConfiguration.lengthCheckZero
                                    ].approval_status === "archived" ? (
                                      <>
                                        Unarchive <br /> account
                                      </>
                                    ) : (
                                      <>
                                        Archive <br /> account
                                      </>
                                    )
                                  }
                                  handleFunction={() => {
                                    if (
                                      payload?.type !==
                                        "field_force_account_detail_modal" &&
                                      viewAccountDetailData
                                        ?.field_force_accounts[0]
                                        .approval_status !== "blocked"
                                    ) {
                                      if (
                                        services?.find(
                                          (service) =>
                                            service === "FFAAccountArchive" ||
                                            service === "Admin",
                                        ) !== undefined
                                      ) {
                                        setArchiveType("archive");
                                        handleUnarchive();
                                        handleArchive();
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService:
                                              "FFAAccountArchive",
                                          },
                                        });
                                      }
                                    } else if (
                                      payload.type ===
                                      "field_force_account_detail_modal"
                                    ) {
                                      actionRestricted();
                                    }
                                  }}
                                  icon={
                                    viewAccountDetailData?.field_force_accounts[
                                      GlobalConfiguration.lengthCheckZero
                                    ].approval_status === "archived"
                                      ? ICONS?.UNARCHIVE
                                      : ICONS?.ARCHIVE
                                  }
                                  enabledTextColor="var(--text-primary)"
                                  enabledBgColor="var(--primary-nav-act)"
                                  disabledBgColor="var(--primary-nav-act)"
                                  hoverOption="white"
                                  isDisabled={
                                    payload.type ===
                                    "field_force_account_detail_modal"
                                  }
                                />
                              )}
                            </div>
                          </div>
                        ),
                      )}
                      {viewAccountDetailData?.field_force_accounts?.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="bene-account-holder-details flex justify-between items-center flex-col Qmd:flex-row"
                          >
                            <div className="flex Qmd:flex-row w-full">
                              <div
                                className={`flex justify-between items-center w-full Qsmd:w-right-half my-margin-sm Qmd:my-margin-base mr-margin-md ml-margin-sm Qmd:mx-margin-base Qmd:h-positive-negative-btn-height ${
                                  account?.approval_status === "pending" ||
                                  account?.approval_status === "approved"
                                    ? ""
                                    : "Qmd:pt-padding-sm Qmd:pb-padding-sm"
                                }`}
                              >
                                <TitleSubtitlePair
                                  title={account?.ifsc_code || account?.ifsc}
                                  titleColor="text-primary "
                                  isDisabled={
                                    payload.type ===
                                    "field_force_account_detail_modal"
                                  }
                                  subtitle="IFSC"
                                  alignRight={false}
                                  hoverOption="white"
                                  isBold={false}
                                  variant="md"
                                  showArrow="true"
                                  onClick={() => {
                                    if (
                                      services?.find(
                                        (service) =>
                                          service === "VIFSC" ||
                                          service === "Admin",
                                      ) !== undefined &&
                                      (account.ifsc_code || account.ifsc)
                                    ) {
                                      if (
                                        payload.type ===
                                        "field_force_account_detail_modal"
                                      ) {
                                        actionRestricted();
                                      } else {
                                        setIfscShowPopup(true);
                                      }
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "VIFSC",
                                        },
                                      });
                                    }
                                  }}
                                />
                              </div>
                              <div
                                className={`py-padding-md hidden lg:w-width-md Qsmd:w-width-sm-1-3 Qlg:flex justify-between ${
                                  ViewAccountDetails[0]?.approval_status ===
                                    "rejected" ||
                                  (ViewAccountDetails[0]?.approval_status ===
                                    "pending" &&
                                    ViewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration.lengthCheckZero)
                                    ? "denied-ifsc-div"
                                    : ""
                                }`}
                              >
                                <div className="account-ifsc-div-main flex flex-row pl-padding-sm Qmd:pl-padding-md w-full"></div>
                              </div>
                            </div>
                            <div
                              className={`flex w-full field-force-detail-actions-col Qmd:h-auto ${
                                (ViewAccountDetails[0]?.approval_status ===
                                  "blocked" ||
                                  ViewAccountDetails[0]?.approval_status ===
                                    "archived" ||
                                  ViewAccountDetails[0]?.approval_status ===
                                    "rejected") &&
                                "hidden"
                              }`}
                            >
                              <div
                                className={`${
                                  viewAccountDetailData?.field_force_accounts[0]
                                    ?.approval_status === "approved"
                                    ? "w-auto flex-grow bg-primary-nav hidden Qmd:block"
                                    : (ViewAccountDetails[0]
                                          ?.approval_status === "rejected" &&
                                          ViewAccountDetails[0]?.error_msg
                                            ?.length >
                                            GlobalConfiguration?.lengthCheckZero) ||
                                        (ViewAccountDetails[0]
                                          ?.approval_status === "pending" &&
                                          ViewAccountDetails[0]?.error_msg
                                            ?.length >
                                            GlobalConfiguration?.lengthCheckZero)
                                      ? "hidden"
                                      : "w-[var(--topnav-small-btn-width)] flex-shrink-0  hidden Qmd:block"
                                }`}
                              ></div>
                              <div
                                className={`${
                                  (ViewAccountDetails[0]?.approval_status ===
                                    "rejected" &&
                                    ViewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration?.lengthCheckZero) ||
                                  (ViewAccountDetails[0]?.approval_status ===
                                    "pending" &&
                                    ViewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration?.lengthCheckZero)
                                    ? "denied-btn-div"
                                    : viewAccountDetailData
                                          ?.field_force_accounts[0]
                                          ?.approval_status === "approved"
                                      ? "w-full"
                                      : "w-full Qmd:w-[calc(2*var(--topnav-small-btn-width))] Qmd:flex-shrink-0 Qmd:bg-primary-nav-act"
                                }`}
                              >
                                <div className="h-full w-full flex justify-end">
                                  {ViewAccountDetails?.map((account) => (
                                    <>
                                      {showLoader ? (
                                        <div className="Qlg:w-max-button-width-for-approval-animation w-full flex">
                                          <div
                                            className={`w-width-full flex justify-center items-center py-padding-lg ${
                                              clickedBtn === "reject"
                                                ? "bg-negative-act"
                                                : "bg-positive-act"
                                            }`}
                                          >
                                            <Loader
                                              height="var(--icon-lg)"
                                              width="var(--icon-lg)"
                                            />
                                          </div>
                                        </div>
                                      ) : account?.approval_status ===
                                        "approved" ? (
                                        <TopNavLargeButton
                                          hoverOption={"black"}
                                          btnText={
                                            <>
                                              Create <br /> request
                                            </>
                                          }
                                          isDisabled={
                                            !(
                                              services?.includes(
                                                "CFieldForceTxn",
                                              ) || services?.includes("Admin")
                                            )
                                          }
                                          btnType={"button"}
                                          handleFunction={() => {
                                            const hasCreateTxnService =
                                              services?.find(
                                                (service) =>
                                                  service ===
                                                    "CFieldForceTxn" ||
                                                  service === "Admin",
                                              ) !== undefined;
                                            if (!hasCreateTxnService) {
                                              navigate(
                                                "/feature_not_assigned",
                                                {
                                                  state: {
                                                    unavailableService:
                                                      "CFieldForceTxn",
                                                  },
                                                },
                                              );
                                              return;
                                            }
                                            if (
                                              !viewAccountDetailData
                                                ?.field_force_accounts[
                                                GlobalConfiguration
                                                  .lengthCheckZero
                                              ]?.category_ids?.length
                                            ) {
                                              CommonToast({
                                                text: "Category can't be blank",
                                                icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                                variant: "var(--error)",
                                                btnProps: {
                                                  isDisabled: false,
                                                  enabledTextColor:
                                                    "var(--text_primary)",
                                                  enabledBgColor:
                                                    "var(--primary_bg)",
                                                },
                                              });
                                              return;
                                            }
                                            navigate(
                                              "/field_force_transaction_dashboard/create_field_force_request",
                                              {
                                                state: {
                                                  ...currentAccountDetails,
                                                  type: "payFieldForceDetails",
                                                },
                                              },
                                            );
                                          }}
                                          icon={ICONS?.PAY_WITH_CIRCLE}
                                          enabledBgColor={"var(--positive-act)"}
                                          enabledTextColor={
                                            "var(--text-primary)"
                                          }
                                          fullWidthRequired={isMobile}
                                        />
                                      ) : account?.approval_status ===
                                          "rejected" &&
                                        account?.error_msg?.length >
                                          GlobalConfiguration?.lengthCheckZero ? (
                                        <div className="h-full flex justify-end">
                                          <div className="flex flex-row gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm">
                                            <div className="flex place-items-center">
                                              <img
                                                src={
                                                  ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                                }
                                                alt="Not found"
                                              />
                                            </div>
                                            <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                              <span className="font-semibold font-sans text-xs text-text-primary">
                                                Failed to take action
                                              </span>
                                              <span className="font-sans text-font_xxs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                                {account?.error_msg}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account?.approval_status ===
                                          "pending" &&
                                        account?.error_msg?.length >
                                          GlobalConfiguration?.lengthCheckZero ? (
                                        <div className="h-full w-full lg:flex lg:justify-end">
                                          <div className="flex flex-row h-full w-full bg-negative-card p-padding-sm gap-gap-sm">
                                            <div className="flex place-items-center">
                                              <img
                                                src={
                                                  ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                                }
                                                alt="Not found"
                                                className="w-icon-lg h-icon-lg mr-margin-button-m"
                                              />
                                            </div>
                                            <div className="flex flex-col justify-center gap-gap-xs w-5/6">
                                              <span className="font-semibold font-sans text-sm text-text-primary">
                                                Failed to take action
                                              </span>
                                              <span className="font-sans text-xs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                                {account?.error_msg}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account?.approval_status ===
                                        "error" ? (
                                        <div className="flex flex-row h-full bg-negative-card p-padding-sm">
                                          <div className="flex place-items-center">
                                            <img
                                              src={
                                                ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                              }
                                              alt="Not found"
                                              className="w-icon-lg h-icon-lg mr-margin-button-m"
                                            />
                                          </div>
                                          <div className="flex flex-col justify-center gap-y-gap-xs w-5/6">
                                            <span className="font-semibold font-sans text-sm text-text-primary">
                                              Failed to take action
                                            </span>
                                            <p className="line-clamp-3 whitespace-wrap overflow-ellipsis text-font_xs text-text-secondary opacity-base_opacity">
                                              {account?.error_msg ||
                                                "Unknown error."}
                                            </p>
                                          </div>
                                        </div>
                                      ) : account?.approval_status ===
                                        "pending" ? (
                                        <div
                                          key={account?.id}
                                          className="h-full flex justify-end w-full"
                                        >
                                          <TopNavSmallButton
                                            btnText={
                                              <>
                                                Reject <br /> account
                                              </>
                                            }
                                            handleFunction={() => {
                                              if (
                                                services?.find(
                                                  (service) =>
                                                    service === "FFAAccount" ||
                                                    service === "Admin",
                                                ) !== undefined
                                              ) {
                                                setClickedBtn("reject");
                                                handleDeclinedDetials(
                                                  account?.id,
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "FFAAccount",
                                                    },
                                                  },
                                                );
                                              }
                                            }}
                                            icon={
                                              ICONS?.REJECT_ICON_RED_WITH_WHITE_CIRCLE
                                            }
                                            isDisabled={
                                              services?.find(
                                                (service) =>
                                                  service === "FFAAccount" ||
                                                  service === "Admin",
                                              ) === undefined
                                            }
                                            enabledBgColor={
                                              "var(--negative-act)"
                                            }
                                            enabledTextColor={
                                              "var(--text-primary"
                                            }
                                            hoverOption="black"
                                            fullWidthRequired={isMobile}
                                          />
                                          <TopNavSmallButton
                                            btnText={
                                              <>
                                                Approve <br /> account
                                              </>
                                            }
                                            handleFunction={() => {
                                              if (
                                                services?.find(
                                                  (service) =>
                                                    service === "FFAAccount" ||
                                                    service === "Admin",
                                                ) !== undefined
                                              ) {
                                                setClickedBtn("approve");
                                                handleApprovalDetails(
                                                  account?.id,
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "FFAAccount",
                                                    },
                                                  },
                                                );
                                              }
                                            }}
                                            isDisabled={
                                              services?.find(
                                                (service) =>
                                                  service === "FFAAccount" ||
                                                  service === "Admin",
                                              ) === undefined
                                            }
                                            icon={
                                              ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK
                                            }
                                            enabledBgColor={
                                              "var(--positive-act)"
                                            }
                                            enabledTextColor={
                                              "var(--text-primary"
                                            }
                                            hoverOption="black"
                                            fullWidthRequired={isMobile}
                                          />
                                        </div>
                                      ) : null}
                                    </>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-primary-bg w-full py-padding-md block Qmd:hidden">
                <div className="text-text-primary pl-padding-sm py-padding-button-l text-font-sm font-semibold bg-primary-card">
                  Quick Actions
                </div>
                <div>
                  <div className="associated-account-transaction-history-block Qmd:hidden flex flex-row border-b border-solid border-primary-bg">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Associated <br /> accounts
                        </>
                      }
                      handleFunction={handleAssociatedAccountsClick}
                      icon={ICONS?.ASSSOCIATED_ACCOUNTS_FOUND}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary"}
                      hoverOption="white"
                      isDisabled={
                        payload.type === "field_force_account_detail_modal"
                      }
                      fullWidthRequired={true}
                    />
                    <div className="flex">
                      <div className="flex-grow border-l border-solid border-primary-bg"></div>
                    </div>
                    <TopNavSmallButton
                      btnText={
                        <>
                          Transaction <br /> history
                        </>
                      }
                      handleFunction={handleTransactionHistoryClick}
                      icon={ICONS?.TRANSACTION_HISTORY}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary"}
                      hoverOption="white"
                      isDisabled={
                        payload.type === "field_force_account_detail_modal"
                      }
                      fullWidthRequired={true}
                    />
                  </div>
                  <div className="flex flex-row bg-primary-nav-act border-b border-solid border-primary-bg">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Request <br /> history
                        </>
                      }
                      handleFunction={handleRequestHistoryClick}
                      icon={ICONS?.TRANSACTION_HISTORY}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary"}
                      disabledBgColor={"var(--primary-nav-act)"}
                      disabledTextColor={"var(--text-primary)"}
                      hoverOption="white"
                      isDisabled={
                        payload.type === "field_force_account_detail_modal"
                      }
                      fullWidthRequired={true}
                    />
                    <div className="flex">
                      <div className="flex-grow border-l border-solid border-primary-bg"></div>
                    </div>
                    {services?.find(
                      (service) =>
                        service === "FFUAccount" || service === "Admin",
                    ) === undefined ||
                    viewAccountDetailData?.field_force_accounts[
                      GlobalConfiguration.lengthCheckZero
                    ].approval_status === "archived" ||
                    viewAccountDetailData?.field_force_accounts[
                      GlobalConfiguration.lengthCheckZero
                    ].approval_status === "blocked" ? (
                      <>
                        <TopNavSmallButton
                          btnText={
                            <>
                              Edit <br /> account
                            </>
                          }
                          handleFunction={() => {
                            if (
                              viewAccountDetailData?.field_force_accounts[
                                GlobalConfiguration.lengthCheckZero
                              ].approval_status !== "archived" &&
                              viewAccountDetailData?.field_force_accounts[
                                GlobalConfiguration.lengthCheckZero
                              ].approval_status !== "blocked"
                            ) {
                              if (
                                services?.find(
                                  (service) =>
                                    service === "FFUAccount" ||
                                    (service === "Admin" &&
                                      payload?.servicesType !== "BenAdmin"),
                                ) !== undefined
                              ) {
                                handleEditAccountClick();
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "FFUAccount",
                                  },
                                });
                              }
                            }
                          }}
                          icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                          enabledBgColor={"var(--primary-nav-act)"}
                          enabledTextColor={"var(--text-primary"}
                          hoverOption="white"
                          isDisabled={
                            payload.type ===
                              "field_force_account_detail_modal" ||
                            services?.find(
                              (service) =>
                                service === "FFUAccount" || service === "Admin",
                            ) === undefined ||
                            viewAccountDetailData?.field_force_accounts[
                              GlobalConfiguration.lengthCheckZero
                            ].approval_status === "archived" ||
                            viewAccountDetailData?.field_force_accounts[
                              GlobalConfiguration.lengthCheckZero
                            ].approval_status === "blocked"
                          }
                          fullWidthRequired={true}
                        />
                      </>
                    ) : (
                      <>
                        <TopNavSmallButton
                          btnText={
                            <>
                              Edit <br /> account
                            </>
                          }
                          handleFunction={() => {
                            if (
                              payload?.type !==
                              "field_force_account_detail_modal"
                            ) {
                              if (
                                services?.find(
                                  (service) =>
                                    service === "FFUAccount" ||
                                    service === "Admin",
                                ) !== undefined
                              ) {
                                handleEditAccountClick();
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "FFUAccount",
                                  },
                                });
                              }
                            } else if (
                              payload.type ===
                              "field_force_account_detail_modal"
                            ) {
                              actionRestricted();
                            }
                          }}
                          icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                          enabledBgColor={"var(--primary-nav-act)"}
                          enabledTextColor={"var(--text-primary"}
                          hoverOption="white"
                          isDisabled={
                            payload.type ===
                              "field_force_account_detail_modal" ||
                            services?.find(
                              (service) =>
                                service === "FFUAccount" || service === "Admin",
                            ) === undefined
                          }
                          fullWidthRequired={true}
                        />
                        {isEditModalOpen && (
                          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
                            <EditCommonPopup
                              btnOneHandleFunction={handleEditModalClose}
                              headerTitle="Select the option to edit:"
                              alertText="Make sure you understand the impact before archiving."
                              alertBackground="emphasis"
                              chipsArray={chipsArray}
                              btnOneText="Cancel"
                              btnOneEnabledBgColor="var(--primary-bg)"
                              btnOneEnabledTextColor="var(--text-primary)"
                              btnOneHoverOption="white"
                              btnOneOutLineColor="var(--text-primary)"
                              btnTwoText="Edit"
                              btnTwoHandleFunction={handleApply}
                              btnTwoIsDisabled={
                                selectedChipIndex === null ||
                                selectedChipIndex ===
                                  GlobalConfiguration.lengthCheckZero
                              }
                              btnTwoDisabledTextColor="var(--text-primary)"
                              btnTwoEnabledBgColor="var(--text-primary)"
                              btnTwoEnabledTextColor="var(--primary-bg)"
                              btnTwoDisabledBgColor="var(--text-disabled)"
                              btnTwoInActiveVariantNeeded={true}
                              btnTwoHoverOption="black"
                              defaultHeight={selectedChipIndex}
                            />
                          </div>
                        )}
                      </>
                    )}
                    <div className="flex">
                      <div className="flex-grow border-l border-solid border-primary-bg"></div>
                    </div>

                    {viewAccountDetailData?.field_force_accounts[
                      GlobalConfiguration.lengthCheckZero
                    ].approval_status === "blocked" ||
                    services?.find(
                      (service) =>
                        service === "FFAAccountArchive" || service === "Admin",
                    ) === undefined ? (
                      <>
                        <TopNavSmallButton
                          btnText={label}
                          handleFunction={() => {
                            if (
                              viewAccountDetailData?.field_force_accounts[
                                GlobalConfiguration.lengthCheckZero
                              ].approval_status !== "blocked"
                            ) {
                              if (
                                services?.find(
                                  (service) =>
                                    service === "FFAAccountArchive" ||
                                    service === "Admin",
                                ) !== undefined
                              ) {
                                setArchiveType("archive");
                                handleUnarchive();
                                handleArchive();
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "FFAAccountArchive",
                                  },
                                });
                              }
                            }
                          }}
                          icon={
                            viewAccountDetailData?.field_force_accounts[0]
                              .approval_status === "archived"
                              ? ICONS?.UNARCHIVE
                              : ICONS?.ARCHIVE
                          }
                          enabledBgColor={"var(--primary-nav-act)"}
                          enabledTextColor={"var(--text-primary"}
                          hoverOption="white"
                          isDisabled={
                            payload.type ===
                              "field_force_account_detail_modal" ||
                            viewAccountDetailData?.field_force_accounts[
                              GlobalConfiguration.lengthCheckZero
                            ].approval_status === "blocked"
                          }
                          fullWidthRequired={true}
                        />
                      </>
                    ) : (
                      <TopNavSmallButton
                        btnText={
                          viewAccountDetailData?.field_force_accounts[
                            GlobalConfiguration.lengthCheckZero
                          ].approval_status === "archived" ? (
                            <>
                              Unarchive <br /> account{" "}
                            </>
                          ) : (
                            <>
                              Archive <br /> account{" "}
                            </>
                          )
                        }
                        handleFunction={() => {
                          if (
                            payload?.type !== "field_force_account_detail_modal"
                          ) {
                            if (
                              services?.find(
                                (service) =>
                                  service === "FFAAccountArchive" ||
                                  service === "Admin",
                              ) !== undefined
                            ) {
                              setArchiveType("archive");
                              handleUnarchive();
                              handleArchive();
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "FFAAccountArchive",
                                },
                              });
                            }
                          } else if (
                            payload.type === "field_force_account_detail_modal"
                          ) {
                            actionRestricted();
                          }
                        }}
                        icon={
                          viewAccountDetailData?.field_force_accounts[
                            GlobalConfiguration.lengthCheckZero
                          ].approval_status === "archived"
                            ? ICONS?.UNARCHIVE
                            : ICONS?.ARCHIVE
                        }
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary"}
                        hoverOption="white"
                        isDisabled={
                          payload.type === "field_force_account_detail_modal"
                        }
                        fullWidthRequired={true}
                      />
                    )}
                  </div>
                  <div className="border-t border-solid border-primary-bg">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Linked <br /> user
                        </>
                      }
                      handleFunction={handleLinkedUser}
                      icon={ICONS?.LINKED_WHITE_CIRCLE}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary)"}
                      disabledBgColor={"var(--primary-nav-act)"}
                      disabledTextColor={"var(--text-primary)"}
                      isDisabled={
                        payload.type === "field_force_account_detail_modal"
                          ? true
                          : services?.find(
                                (service) =>
                                  service === "VSpecificEmp" ||
                                  service === "Admin",
                              ) !== undefined &&
                              viewAccountDetailData?.field_force_accounts?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.field_force_user_full_name
                            ? false
                            : viewAccountDetailData?.field_force_accounts?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.field_force_user_full_name
                              ? false
                              : true
                      }
                      hoverOption="white"
                      fullWidthRequired={true}
                    />
                  </div>
                </div>
              </div>
              <div
                className={`bg-primary-bg flex-grow w-full ${payload.type === "field_force_account_detail_modal" && "pb-padding-lg"}`}
              >
                <div className="w-full bg-primary-card">
                  <div className="w-full lg:w-max-content-width m-auto">
                    <CommonAlertsStrip alerts={buildAlerts()} />
                  </div>
                </div>

                <div className="h-auto max-w-tab-width-normal bg-primary-bg m-auto">
                  <div className="detail-category-button w-full ml-margin-md lg:ml-margin-base flex Qmd:pt-padding-md pb-padding-md lg:mx-auto Qmd:mx-margin-md Qlg:mx-margin-base">
                    <div
                      className="overflow-x-auto scroll-bar mt-margin-md Qsmd:mt-margin-base"
                      style={{ scrollbarWidth: "none" }}
                    >
                      <SwitcherTabs
                        tabs={[
                          {
                            label: "Account details",
                            key: "Account details",
                            handler: toggleContactDetails,
                          },
                          {
                            label: "Categories",
                            key: "Categories",
                            handler: toggleCategories,
                          },
                          {
                            label: "Labels",
                            key: "Labels",
                            handler: toggleAssignedLabels,
                          },
                          {
                            label: "Recipients",
                            key: "Recipients",
                            handler: toggleAdditionalRecipicent,
                          },
                          {
                            label: "Support details",
                            key: "Support details",
                            handler: toggleSupportDetails,
                          },
                        ]}
                        swicherTabBgColor={"var(--primary-card)"}
                        initialActiveTab={
                          index === GlobalConfiguration?.lengthCheckOne
                            ? "Categories"
                            : index === GlobalConfiguration?.lengthCheckTwo
                              ? "Labels"
                              : index === GlobalConfiguration?.lengthCheckThree
                                ? "Recipients"
                                : index === GlobalConfiguration?.lengthCheckFour
                                  ? "Support details"
                                  : "Account details"
                        }
                        setIndex={setIndex}
                      />
                    </div>
                  </div>

                  <div className="relative pb-padding-md">
                    {index === GlobalConfiguration?.lengthCheckZero && (
                      <div className={animationClass}>
                        {ViewAccountDetails?.map((account) => {
                          let originItemList = [
                            {
                              content: "+91 " + account.contact_no ?? "",
                              heading: "Contact number",
                              type: "text",
                            },
                            {
                              content: account?.email_id,
                              heading: "Email ID",
                              type: "text",
                            },
                          ];

                          let AccountItemList = [
                            {
                              content: account?.pan_no,
                              heading: "PAN",
                              type: "text",

                              onClick: () => {
                                const hasAccess = services?.some(
                                  (service) =>
                                    service === "VPAN" || service === "Admin",
                                );

                                if (hasAccess && account?.pan_no) {
                                  if (
                                    payload.type ===
                                    "field_force_account_detail_modal"
                                  ) {
                                    actionRestricted();
                                  } else {
                                    handlePANDetails(account.pan_no);
                                  }
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: { unavailableService: "VPAN" },
                                  });
                                }
                              },

                              isDisabled:
                                services?.some(
                                  (service) =>
                                    service === "VPAN" || service === "Admin",
                                ) &&
                                account?.pan_no &&
                                payload.type !==
                                  "field_force_account_detail_modal"
                                  ? false
                                  : true,
                            },

                            {
                              content: account?.pan_legal_name,
                              heading: "Legal name",
                              type: "text",
                            },
                            {
                              content: account.gstin_detail
                                ? account.gstin_detail
                                : "Not Given",
                              heading: "GST number",
                              type: "text",

                              onClick: account?.gstin_detail
                                ? () => {
                                    if (
                                      payload.type ===
                                      "field_force_account_detail_modal"
                                    ) {
                                      actionRestricted();
                                    } else {
                                      const hasAccess =
                                        services?.includes("VGSTIN") ||
                                        services?.includes("Admin");

                                      if (hasAccess) {
                                        setGstShowPopup(true);
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "VGSTIN",
                                          },
                                        });
                                      }
                                    }
                                  }
                                : undefined,
                              isDisabled:
                                payload.type ===
                                  "field_force_account_detail_modal" &&
                                !account.gstin_detail
                                  ? false
                                  : !(
                                      services?.some(
                                        (s) => s === "VPAN" || s === "Admin",
                                      ) &&
                                      account?.pan_no &&
                                      payload.type !==
                                        "field_force_account_detail_modal"
                                    ),
                            },

                            ...(account?.virtual_account === "Y"
                              ? [
                                  {
                                    content:
                                      account?.virtual_account === "N"
                                        ? ""
                                        : account?.virtual_account_type ===
                                            "manual"
                                          ? "Manually created"
                                          : account?.virtual_account_type ===
                                              "automated" && "Auto detected",
                                    heading:
                                      account?.virtual_account === "N"
                                        ? ""
                                        : "Virtual account",
                                    type: "text",
                                  },
                                ]
                              : []),
                            {
                              content: account.account_type,
                              heading: "Account state",
                              type: "text",
                            },
                          ];

                          return (
                            <div className="flex flex-col lg:flex-row mb-margin-xl gap-gap-md mx-margin-md lg:mx-auto">
                              <CommonDetailCard
                                cardTitle="Account Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={AccountItemList}
                              />
                              <CommonDetailCard
                                cardTitle="Contact Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={originItemList}
                              />
                              {/* <CommonDetailCard
                                cardTitle="Origin Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="fourth"
                                entries={originTimelineItemList}
                              />
                              <CommonDetailCard
                                cardTitle="Support Information"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="fourth"
                                entries={SupportInformationList}
                              /> */}
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {index === GlobalConfiguration?.lengthCheckOne && (
                      <div className={animationClass}>
                        <CommonContainerCard
                          header={TEXT?.ASSIGNED_FIELD_FORCE_CATEGORIES}
                          iconIsDisabled={
                            payload?.type === "field_force_account_detail_modal"
                              ? true
                              : isArchived
                          }
                          icon={ICONS?.EDIT}
                          handleFunction={() => {
                            if (
                              payload?.type !==
                              "field_force_account_detail_modal"
                            ) {
                              if (
                                services?.find(
                                  (service) =>
                                    service === "FFUAccount" ||
                                    service === "Admin",
                                ) !== undefined
                              ) {
                                handleEditAccountClick(
                                  GlobalConfiguration.lengthCheckTwo,
                                );
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "FFUAccount",
                                  },
                                });
                              }
                            } else if (
                              payload.type ===
                              "field_force_account_detail_modal"
                            ) {
                              actionRestricted();
                            }
                          }}
                        >
                          {sliceCategory.filter((item) => item.active === "Y")
                            .length ===
                          viewAccountDetailData?.field_force_accounts[
                            GlobalConfiguration.lengthCheckZero
                          ]?.category_ids
                            ?.map((cat) => cat.category_name)
                            .join(",").length ? (
                            <div className="flex mb-margin-button-l items-center">
                              <img
                                className="w-icon-md h-icon-md mr-margin-sm"
                                src={ICONS?.ALERT}
                                alt=""
                              />
                              <p className="text-text-primary text-sm font-normal">
                                {TEXT?.ALL_CATEGORIES_ASSIGNED_WARNING}
                              </p>
                            </div>
                          ) : (
                            ""
                          )}
                          <div
                            className={`${
                              viewAccountDetailData?.field_force_accounts[
                                GlobalConfiguration.lengthCheckZero
                              ]?.category_ids
                                ?.map((cat) => cat.category_name)
                                .join(",").length >
                              GlobalConfiguration?.lengthCheckZero
                                ? "assigned-beneficiary-categories-data-div"
                                : ""
                            }`}
                          >
                            {viewAccountDetailData?.field_force_accounts?.map(
                              (account, index) => (
                                <div key={index}>
                                  <Box className="flex flex-col Qmd:flex-row Qmd:flex-wrap gap-gap-sm">
                                    {account?.category_ids
                                      ? account?.category_ids?.map(
                                          (category, categoryIndex) => (
                                            <div
                                              className="w-full bg-primary-nav-act rounded-border-radius-sm max-w-none Qmd:max-w-detail-page-category-grid flex flex-row items-center"
                                              key={
                                                category?.category_id ??
                                                categoryIndex
                                              }
                                            >
                                              <div className="bg-text-secondary rounded-border-radius-sm flex justify-center items-center opacity-base-opacity">
                                                <div className="w-icon-lg h-icon-lg my-margin-button-s mx-margin-sm max-w-none">
                                                  <SVGComponent
                                                    url={
                                                      categoryMapper(
                                                        category.category_id,
                                                      )?.url
                                                    }
                                                    color={
                                                      categoryMapper(
                                                        category.category_id,
                                                      )?.colour
                                                    }
                                                  />
                                                </div>
                                              </div>
                                              <div className="truncate px-padding-sm text-sm text-text-primary text-left font-sans font-semibold opacity-base-opacity antialiased">
                                                <TickerAnimation
                                                  text={category?.category_name?.trim()}
                                                />
                                              </div>
                                            </div>
                                          ),
                                        )
                                      : null}
                                  </Box>

                                  {!account?.category_ids
                                    ?.map((category) => category.category_name)
                                    .join()
                                    .split() && (
                                    <p
                                      key={`notFound_${index}`}
                                      className="antialiased text-text-primary text-sm"
                                    >
                                      {
                                        TEXT?.ASSIGN_CATEGORY_FIELD_FORCE_WARNING
                                      }
                                    </p>
                                  )}
                                </div>
                              ),
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    )}

                    {index === GlobalConfiguration?.lengthCheckTwo && (
                      <div className={animationClass}>
                        <CommonContainerCard
                          header="Assigned Labels"
                          subheader="Labels will be used to generate statistics for the associated accounts."
                          handleFunction={(e) => {
                            e.stopPropagation();
                            if (
                              !services?.includes("ALabel") &&
                              !services?.includes("RLabel")
                            ) {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "ALabel,RLabel",
                                },
                              });
                              return;
                            }
                            if (
                              payload?.type ===
                              "field_force_account_detail_modal"
                            ) {
                              actionRestricted();
                              return;
                            }
                            setShowLabelsPopup(true);
                          }}
                          icon={ICONS?.EDIT}
                          iconIsDisabled={
                            payload?.type === "field_force_account_detail_modal"
                          }
                        >
                          <div className="flex flex-wrap w-full gap-gap-sm">
                            {Array.isArray(labelDetails) &&
                            labelDetails.length >
                              GlobalConfiguration.lengthCheckZero ? (
                              <>
                                {labelDetails.map((item, index) => (
                                  <Chips
                                    txtChip={item}
                                    enabledTextColor="var(--text-primary)"
                                    enabledBgColor="var(--primary-nav)"
                                    isTickerRequired={false}
                                  />
                                ))}
                              </>
                            ) : (
                              <p className="text-font-sm text-text-primary">
                                Not assigned.
                              </p>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    )}
                    {index === GlobalConfiguration?.lengthCheckThree && (
                      <div className={animationClass}>
                        <CommonContainerCard
                          header={TEXT?.ADDITIONAL_RECIPIENTS}
                          subheader={TEXT?.ADDITIONAL_RECIPIENTS_CARD_SUBTEXT}
                          icon={ICONS?.EDIT}
                          handleFunction={() => {
                            if (
                              payload?.type !==
                              "field_force_account_detail_modal"
                            ) {
                              if (
                                services?.find(
                                  (service) =>
                                    service === "FFUAccount" ||
                                    service === "Admin",
                                ) !== undefined
                              ) {
                                handleEditAccountClick(
                                  GlobalConfiguration.lengthCheckThree,
                                );
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "FFUAccount",
                                  },
                                });
                              }
                            } else if (
                              payload.type ===
                              "field_force_account_detail_modal"
                            ) {
                              actionRestricted();
                            }
                          }}
                          iconIsDisabled={
                            !ensureAll(["FFUAccount"]).status
                              ? true
                              : ViewAccountDetails[
                                    GlobalConfiguration.lengthCheckZero
                                  ].approval_status === "archived" ||
                                  ViewAccountDetails[
                                    GlobalConfiguration.lengthCheckZero
                                  ].approval_status === "blocked"
                                ? true
                                : payload?.type ===
                                    "field_force_account_detail_modal"
                                  ? true
                                  : false
                          }
                        >
                          <div className="flex flex-wrap w-full gap-gap-sm">
                            {Array.isArray(showAdditionalRecipient) &&
                            showAdditionalRecipient.length >
                              GlobalConfiguration?.lengthCheckZero ? (
                              <>
                                {showAdditionalRecipient.map((item, index) => (
                                  <div
                                    key={index}
                                    className="flex flex-row items-center py-padding-button-m px-padding-button-l rounded-border-radius-md relative bg-primary-nav-act max-w-max_width-full"
                                  >
                                    <span className="text-text-primary text-font-xs font-normal break-all">
                                      {linkIdentifier(item)}
                                    </span>
                                  </div>
                                ))}
                              </>
                            ) : (
                              <span className="text-text-primary text-sm font-normal">
                                Not given.
                              </span>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    )}

                    {index === GlobalConfiguration?.lengthCheckFour && (
                      <div className={animationClass}>
                        {ViewAccountDetails.map((account) => {
                          let originTimelineItemList = [
                            {
                              content: account.created_by_name || "Not given",
                              heading: "Created by",
                              type: "text",
                            },
                            {
                              content: account.created_on
                                ? formatDateViewAll(
                                    account.created_on,
                                    true,
                                    true,
                                  )
                                : "Not given",
                              heading: "Created on",
                              type: "text",
                            },

                            ...(account.approval_status === "approved"
                              ? [
                                  {
                                    content:
                                      account.approved_by_name || "Not given",
                                    heading: "Approved by",
                                    type: "text",
                                  },
                                  {
                                    content: account.approved_on
                                      ? formatDateViewAll(
                                          account.approved_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    heading: "Approved on",
                                    type: "text",
                                  },
                                ]
                              : []),

                            ...(account.approval_status === "rejected"
                              ? [
                                  {
                                    content:
                                      account.rejected_by_name || "Not given",
                                    heading: "Rejected by",
                                    type: "text",
                                  },
                                  {
                                    content: account.rejected_on
                                      ? formatDateViewAll(
                                          account.rejected_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    heading: "Rejected on",
                                    type: "text",
                                  },
                                  {
                                    content:
                                      account.rejection_reason || "Not given",
                                    heading: "Rejected reason",
                                    type: "text",
                                  },
                                ]
                              : []),

                            ...(account.approval_status === "archived"
                              ? [
                                  {
                                    content:
                                      account.archived === "Y" &&
                                      !account.archived_by_name
                                        ? nameArchive
                                        : account.archived_by_name ||
                                          "Not given",
                                    heading: "Archived by",
                                    type: "text",
                                  },
                                  {
                                    content: account.archived_on
                                      ? formatDateViewAll(
                                          account.archived_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    heading: "Archived on",
                                    type: "text",
                                  },
                                ]
                              : []),

                            ...(account.approval_status === "blocked"
                              ? [
                                  {
                                    content:
                                      account.blocked_by_name || "Not given",
                                    heading: "Blocked by",
                                    type: "text",
                                  },
                                  {
                                    content: account.blocked_on
                                      ? formatDateViewAll(
                                          account.blocked_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    heading: "Blocked on",
                                    type: "text",
                                  },
                                ]
                              : []),
                          ];

                          let SupportInformationList = [
                            {
                              content: account.id,
                              heading: "Account ID",
                              type: "textWithButton",
                              iconArray: [
                                {
                                  onClick: (e) => handleSupportIdCopy(),
                                  title: tooltip,
                                  icon:
                                    tooltip === "Copied"
                                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                      : ICONS?.COPY,
                                },
                              ],
                            },
                          ];
                          return (
                            <div
                              key={account.id}
                              className="flex flex-col lg:flex-row mb-margin-xl gap-gap-md mx-margin-md lg:mx-auto"
                            >
                              <CommonDetailCard
                                cardTitle="Origin Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={originTimelineItemList}
                              />
                              <CommonDetailCard
                                cardTitle="Support Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={SupportInformationList}
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default FieldForceAccountDetails;
